import { useState, useEffect, useRef } from "react";
// import Certificate from "../Forms/Certificate";
import { useNavigate, useLocation } from "react-router-dom";
import API_URL from "../Config";
import axiosInstance from "../axiosinstance";
import SearchBar from "../Components/SearchBar.js";
import PaginationFooter from "../Components/PaginationFooter.js";
import TicketModalTextFields from "../Components/TicketModalTextFields.js";
import AllTags from "./AllTags.js";
import EquipmentMultiSelectDropdown from "./EquipmentMultiSelectDropdown.js";
import { LiaQrcodeSolid } from "react-icons/lia";
import { MdLocalPrintshop } from "react-icons/md";
import { BiEditAlt } from "react-icons/bi";
import html2pdf from "html2pdf.js";
import { IoWarningOutline } from "react-icons/io5";
import { LuLayers } from "react-icons/lu";
import { MdOutlinePrint } from "react-icons/md";
import { GrFormView } from "react-icons/gr";
import FlangeDetails from "../View/FlangeDetail";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiFlag2Fill } from "react-icons/ri";
import { LuTicketSlash } from "react-icons/lu";
import { MdOutlineArchive } from "react-icons/md";
import { MdOutlineUnarchive } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoChevronDown } from "react-icons/io5";
import Loader from "../Components/Loader";
import { PiExport } from "react-icons/pi";
import { GoIssueReopened } from "react-icons/go";
import "./Flanges.css";
import "./QrModal.css";
import "./TicketModal.css";
import {
  History,
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  Image as ImageIcon,
  Warning as WarningIcon,
  Delete as DeleteIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Lock as LockIcon,
} from "@mui/icons-material";
import { withMandatoryDepartments } from "../utils/mandatoryAssignees";
import Select from "react-select";
import MUISelect from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";

import {
  Box,
  Link,
  IconButton,
  Modal,
  Typography,
  FormControlLabel,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  // Select,
  MenuItem,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Badge,
} from "@mui/material";
import { createPortal } from "react-dom";
import { Snackbar, Alert as MuiAlert } from "@mui/material";
import ReopenFlangeDialog from "../Components/ReopenFlangeDialog.js";
// import FlangeDetails from "./FlangeDetails";
const ALL_FLANGES_LIST_STATE_KEY = "all_flanges_list_state_v1";

const TICKET_PRIORITY_OPTIONS = [
  { value: "Low", color: "#2e7d32" },
  { value: "Medium", color: "#b45309" },
  { value: "High", color: "#e65100" },
  { value: "Critical", color: "#d32f2f" },
];

const getTicketUserDepartments = (user) =>
  Array.isArray(user?.departments)
    ? user.departments
        .map((department) => department?.name)
        .filter(Boolean)
    : [];

const getTicketUserDepartmentLabel = (user) => {
  const departments = getTicketUserDepartments(user);
  if (departments.length === 0) return "No department";
  if (departments.length === 1) return departments[0];
  return `${departments[0]} +${departments.length - 1}`;
};

const getTicketUserDepartmentText = (user) => {
  const departments = getTicketUserDepartments(user);
  return departments.length ? `Dept: ${departments.join(", ")}` : "No department";
};

const getTicketUserChipLabel = (user) => {
  if (!user?.name) return "";
  const departmentLabel = getTicketUserDepartmentLabel(user);
  return departmentLabel === "No department"
    ? user.name
    : `${user.name} (${departmentLabel})`;
};

const getTicketUserSearchText = (user) =>
  [
    user?.name,
    user?.email,
    ...getTicketUserDepartments(user),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

const filterTicketAssigneeUsers = (options, { inputValue }) => {
  const query = inputValue.trim().toLowerCase();
  if (!query) return options;
  return options.filter((option) =>
    getTicketUserSearchText(option).includes(query),
  );
};

const filterTicketDepartments = (options, { inputValue }) => {
  const query = inputValue.trim().toLowerCase();
  if (!query) return options;
  return options.filter((option) =>
    [option?.name, option?.code]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(query),
  );
};

const TICKET_AUTOCOMPLETE_SLOT_PROPS = {
  popper: {
    placement: "bottom-start",
    modifiers: [{ name: "flip", enabled: false }],
  },
  paper: {
    sx: {
      mt: 0.5,
      border: "1px solid #d8dee9",
      borderRadius: 2,
      boxShadow: "0 14px 34px rgba(15, 23, 42, 0.14)",
      overflow: "hidden",
    },
  },
  listbox: {
    sx: {
      maxHeight: 180,
      py: 0.5,
      "& .MuiAutocomplete-option": {
        color: "#1f2937",
        transition: "background-color 0.12s ease, color 0.12s ease",
      },
      "& .MuiAutocomplete-option.Mui-focused": {
        bgcolor: "#fff7f7",
      },
      "& .MuiAutocomplete-option[aria-selected='true']": {
        bgcolor: "#fff1f2",
        color: "#7f1d1d",
      },
      "& .MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
        bgcolor: "#ffe4e6",
      },
    },
  },
};

function AllFlanges({ isSidebarExpanded }) {
  const isAdmin =
    (localStorage.getItem("role_name") || "").toLowerCase() === "admin";
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [pageLoading, setPageLoading] = useState(false);
  const isInitialLoad = useRef(true);
  const [Flanges, setFlanges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // const [selectedCertificateId, setSelectedCertificateId] = useState(null); // State to track the selected certificate
  const navigate = useNavigate();
  const location = useLocation();
  const [highlightedFlangeId, setHighlightedFlangeId] = useState(null);
  const [pulsedFlangeId, setPulsedFlangeId] = useState(null);
  const handledScrollTargetsRef = useRef(new Set());
  const highlightTimeoutRef = useRef(null);
  const pulseTimeoutRef = useRef(null);
  const lastProjectRef = useRef("");
  const skipNextSearchPageResetRef = useRef(false);

  const [activeTab, setActiveTab] = useState("All Flanges");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [editProcessId, setEditProcessId] = useState(null);

  const [selectedFlange, setSelectedFlange] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);
  const [tagPreviewLoading, setTagPreviewLoading] = useState(false);
  const [tagPrintPreparing, setTagPrintPreparing] = useState(false);
  const [printingAllTags, setPrintingAllTags] = useState(false);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const [selectedProject, setSelectedProject] = useState(() => {
    // Load once from localStorage on component mount
    return JSON.parse(localStorage.getItem("selectedProject")) || [];
  });

  // for print
  const [selectedFlanges, setSelectedFlanges] = useState([]);

  // warning

  const [selectedWarnings, setSelectedWarnings] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [selectedEquipmentNumbers, setSelectedEquipmentNumbers] = useState([]);
  const [selectedEquipNames, setSelectedEquipNames] = useState([]);
  const [selectedEquipNumbers, setSelectedEquipNumbers] = useState([]);

  const [isSearching, setIsSearching] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const searchDebounceRef = useRef(null);

  // debounced setter
  // const handleSearchChange = (value) => {
  //   const trimmedValue = (value ?? "").trim();
  //   setSearchQuery(trimmedValue);
  //   setCurrentPage(1); // reset to page 1 on new search

  //   //  Remove the debounce and fetchCalls
  //   // The useEffect will handle fetching when searchQuery changes
  // };

  const handleSearchChange = (value) => {
    const trimmedValue = (value ?? "").trim();
    setSearchQuery(trimmedValue);
    if (skipNextSearchPageResetRef.current) {
      skipNextSearchPageResetRef.current = false;
    } else {
      setCurrentPage(1);
    }
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFlangeId, setSelectedFlangeId] = useState(null);

  const uniqueEquipment = Array.from(
    new Set(
      selectedFlanges.map((f) =>
        JSON.stringify({ no: f.equipmentNo, name: f.equipmentName }),
      ),
    ),
  ).map((s) => JSON.parse(s));
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [ignoreScope, setIgnoreScope] = useState("equipment");
  const [selectedEquipmentName, setSelectedEquipmentName] = useState("");
  const [reason, setReason] = useState("");
  const [avoidReason, setAvoidReason] = useState("");
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  // const warningTypes = [ /* ... same list ... */ ];
  const [uniqueEquipmentWar, setUniqueEquipmentWar] = useState([]);
  const [warningTypes, setWarningTypes] = useState([]);
  const [selectedWarningType, setSelectedWarningType] = useState([]);
  const [isTypesOpen, setIsTypesOpen] = useState(false);

  // Archive / Un-Archive dialog state
  const [auOpen, setAuOpen] = useState(false);
  const [auAction, setAuAction] = useState("archive"); // "archive" | "unarchive"
  const [auRemark, setAuRemark] = useState("");
  const [auTargetId, setAuTargetId] = useState(null);
  const [auSubmitting, setAuSubmitting] = useState(false);

  // Local immediate icon flip (fallback while list refetches)
  const [archivedMap, setArchivedMap] = useState({});

  // Ticket Modal states
  const [showTicketModal, setShowTicketModal] = useState(false);
  const ticketTitleRef = useRef("");
  const ticketDescriptionRef = useRef("");
  const [hasTicketTitle, setHasTicketTitle] = useState(false);
  const [ticketType, setTicketType] = useState("Missing Information");
  const [ticketPriority, setTicketPriority] = useState("Medium");
  const [ticketAssigneeUsers, setTicketAssigneeUsers] = useState([]);
  const [ticketAssigneeDepartments, setTicketAssigneeDepartments] = useState([]);
  const [ticketAttachments, setTicketAttachments] = useState([]);
  const [assignableUsers, setAssignableUsers] = useState([]);
  const [assignableDepartments, setAssignableDepartments] = useState([]);
  const [assignablesLoading, setAssignablesLoading] = useState(false);
  const handleOpenTicketModal = (flangeId) => {
    setSelectedFlangeId(flangeId);
    setShowTicketModal(true);
  };

  const handleCloseTicketModal = () => {
    setShowTicketModal(false);
    // Reset all fields
    ticketTitleRef.current = "";
    ticketDescriptionRef.current = "";
    setHasTicketTitle(false);
    setTicketType("Missing Information");
    setTicketPriority("Medium");
    setTicketAssigneeUsers([]);
    setTicketAssigneeDepartments([]);
    setTicketAttachments([]);
    setSelectedFlangeId(null);
  };

  // Fetch the project's assignable users/departments whenever the ticket
  // modal opens, so the assignment pickers reflect who can actually be
  // assigned on this project.
  useEffect(() => {
    if (!showTicketModal) return;
    const projectId = selectedProject?.id || selectedProject;
    if (!projectId) {
      setAssignableUsers([]);
      setAssignableDepartments([]);
      return;
    }

    let cancelled = false;
    setAssignablesLoading(true);
    axiosInstance
      .get(`${API_URL}/api/projects/${projectId}/assignable-users`)
      .then((response) => {
        if (cancelled) return;
        const depts = response.data?.data?.departments || [];
        setAssignableUsers(response.data?.data?.users || []);
        setAssignableDepartments(depts);
        // Pre-select the mandatory (planning) department(s) so the creator sees
        // up front that they'll be assigned — they can't be removed.
        setTicketAssigneeDepartments((prev) =>
          withMandatoryDepartments(prev, depts),
        );
      })
      .catch(() => {
        if (cancelled) return;
        setAssignableUsers([]);
        setAssignableDepartments([]);
      })
      .finally(() => {
        if (!cancelled) setAssignablesLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [showTicketModal, selectedProject]);

  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const accepted = Array.from(files).filter(
        (file) =>
          file.type.startsWith("image/") || file.type.startsWith("video/"),
      );
      if (accepted.length === 0) {
        toast.error("Please upload image or video files only");
        return;
      }
      if (accepted.length < files.length) {
        toast.error(
          "Some files were skipped — only images and videos are allowed",
        );
      }
      setTicketAttachments((prev) => [...prev, ...accepted]);
    }
  };

  // Reopen dialog state
  const [reOpenOpen, setReOpenOpen] = useState(false);
  const [reOpenTargetId, setReOpenTargetId] = useState(null);
  const [reOpenSubmitting, setReOpenSubmitting] = useState(false);

  const submitReOpen = async (remark) => {
    if (!reOpenTargetId) {
      toast.error("Missing flange id");
      return;
    }

    try {
      setReOpenSubmitting(true);

      const url = `${API_URL}/api/reopening/${reOpenTargetId}`;
      const fd = new FormData();
      fd.append("remark", remark);

      // ✅ axiosInstance already attaches Authorization header
      const res = await axiosInstance.post(url, fd);

      const data = res.data || {};

      toast.success(data?.message || "Flange reopened successfully.");
      setReOpenOpen(false);
      setReOpenTargetId(null);

      // refresh list
      window.dispatchEvent(new Event("flangeUpdated"));
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        "Reopen request failed";
      toast.error(msg);
      console.error(e);
    } finally {
      setReOpenSubmitting(false);
    }
  };

  const handleStatusesChange = (next) => {
    setSelectedStatuses(next);
    setCurrentPage(1);
  };

  const handleEquipNamesChange = (next) => {
    setSelectedEquipNames(next);
    setCurrentPage(1);
  };

  const handleEquipNumbersChange = (next) => {
    setSelectedEquipNumbers(next);
    setCurrentPage(1);
  };

  // ------ Status  Dropdown ------- //
  const [selectedStatuses, setSelectedStatuses] = useState([]);

  const [groupDropdownOpen, setGroupDropdownOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Add debounce timer refs
  const nameFilterTimeoutRef = useRef(null);
  const tagFilterTimeoutRef = useRef(null);
  const isFirstLoad = useRef(true);

  const StatusFilter = ({
    projectId,
    selected = [],
    onChange,
    disabled = false,
  }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]); // array of strings
    const [error, setError] = useState("");
    const boxRef = useRef(null);
    const searchDebounce = useRef(null);

    // Close on outside click
    useEffect(() => {
      const handler = (e) => {
        if (boxRef.current && !boxRef.current.contains(e.target))
          setOpen(false);
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, []);

    const fetchStatuses = async (q = "") => {
      if (!projectId) return;
      try {
        setLoading(true);
        setError("");
        const res = await axiosInstance.get(
          `${API_URL}/api/get_all_statuses/${projectId}`,
          { params: { search: q || "" } },
        );
        const list = Array.isArray(res?.data?.statuses)
          ? res.data.statuses
          : [];
        setOptions(list);
      } catch (err) {
        console.error(
          "status fetch failed:",
          err?.response?.data || err?.message,
        );
        setError("Failed to load statuses");
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    // initial + when dropdown opens
    useEffect(() => {
      if (open) fetchStatuses("");
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, projectId]);

    // debounced type-ahead
    useEffect(() => {
      if (!open) return;
      if (searchDebounce.current) clearTimeout(searchDebounce.current);
      searchDebounce.current = setTimeout(() => fetchStatuses(search), 300);
      return () => clearTimeout(searchDebounce.current);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const toggle = (val) => {
      if (!val) return;
      if (selected.includes(val)) {
        onChange(selected.filter((s) => s !== val));
      } else {
        onChange([...selected, val]);
      }
    };

    const clearAll = () => onChange([]);
    const selectAllVisible = () => {
      const merged = Array.from(new Set([...selected, ...options]));
      onChange(merged);
    };

    return (
      <div className="status-filter" ref={boxRef}>
        <button
          type="button"
          className="btn d-flex align-items-center gap-2"
          onClick={() => setOpen((o) => !o)}
          disabled={disabled || !projectId}
          style={{
            minWidth: 140,
            backgroundColor: "#fff",
            border: "1px solid #cbd5e1",
            color: "#334155",
          }}
        >
          Status
          {selected.length > 0 && (
            <span className="badge bg-primary ms-4 rounded-pill">
              {selected.length}
            </span>
          )}
          <span className="ms-auto">
            <IoChevronDown />
          </span>
        </button>
        {selected.length > 0 && (
          <button
            type="button"
            className="filter-quick-clear"
            aria-label={`Clear ${selected.length} selected status filter${selected.length === 1 ? "" : "s"}`}
            title="Clear status filter"
            onClick={() => {
              clearAll();
              setOpen(false);
            }}
            disabled={disabled}
          >
            <CloseIcon fontSize="inherit" />
          </button>
        )}

        {open && (
          <div
            className="dropdown-menu show p-2 mt-2 shadow"
            style={{ width: 210, maxHeight: 320, overflow: "auto" }}
          >
            {/* Search */}
            <div className="mb-2">
              <input
                className="form-control form-control-sm"
                placeholder="Search status..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                autoFocus
              />
            </div>

            {/* Quick actions */}
            <div className="d-flex justify-content-between mb-2">
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={clearAll}
              >
                Clear
              </button>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={selectAllVisible}
                disabled={options.length === 0}
              >
                Select All
              </button>
            </div>

            {/* Options */}
            {loading && <div className="small text-muted px-1">Loading…</div>}
            {error && <div className="text-danger small px-1">{error}</div>}
            {!loading && !error && options.length === 0 && (
              <div className="small text-muted px-1">No statuses</div>
            )}

            <ul className="list-unstyled mb-0">
              {options.map((opt) => (
                <li key={opt} className="d-flex align-items-center py-1 px-1">
                  <input
                    id={`status-${opt}`}
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={selected.includes(opt)}
                    onChange={() => toggle(opt)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`status-${opt}`}
                    style={{ cursor: "pointer" }}
                  >
                    {opt}
                  </label>
                </li>
              ))}
            </ul>

            {/* Selected chips */}
            {/* {selected.length > 0 && (
              <>
                <hr className="my-2" />
                <div className="d-flex flex-wrap gap-1">
                  {selected.map((s) => (
                    <span key={s} className="badge bg-secondary">
                      {s}{" "}
                      <button
                        type="button"
                        className="btn-close btn-close-white btn-sm ms-1"
                        aria-label="Remove"
                        onClick={() => toggle(s)}
                        style={{ transform: "scale(.7)" }}
                      />
                    </span>
                  ))}
                </div>
              </>
            )} */}
          </div>
        )}
      </div>
    );
  };

  // --- EquipmentNameDropdown --- //
  const EquipmentNameDropdown = ({
    projectId,
    selected = [], // array of strings (group_name)
    onChange, // (nextArray) => void
    disabled = false,
  }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]); // strings
    const [error, setError] = useState("");

    const btnRef = useRef(null);
    const menuRef = useRef(null);
    const searchDebounce = useRef(null);

    // portal menu positioning (avoid overflow)
    const [menuPos, setMenuPos] = useState({
      top: 0,
      left: 0,
      width: 300,
      maxH: 320,
      place: "bottom",
    });

    const computeMenuPos = () => {
      if (!btnRef.current) return;
      const r = btnRef.current.getBoundingClientRect();
      const desiredW = 300,
        desiredH = 320,
        gutter = 8;

      const left = Math.min(
        Math.max(gutter, r.left),
        window.innerWidth - desiredW - gutter,
      );

      const spaceBelow = window.innerHeight - r.bottom - gutter;
      const spaceAbove = r.top - gutter;

      let top = r.bottom + 6;
      let maxH = Math.min(desiredH, spaceBelow);

      if (spaceBelow < Math.min(200, desiredH) && spaceAbove > spaceBelow) {
        maxH = Math.min(desiredH, spaceAbove);
        top = Math.max(gutter, r.top - maxH - 6);
      }

      setMenuPos({ top, left, width: desiredW, maxH, place: "bottom" });
    };

    // close on outside click
    useEffect(() => {
      const handler = (e) => {
        if (!open) return;
        const m = menuRef.current,
          b = btnRef.current;
        if ((m && m.contains(e.target)) || (b && b.contains(e.target))) return;
        setOpen(false);
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, [open]);

    // reposition while open
    useEffect(() => {
      if (!open) return;
      computeMenuPos();
      const onScrollOrResize = () => computeMenuPos();
      window.addEventListener("resize", onScrollOrResize);
      window.addEventListener("scroll", onScrollOrResize, true);
      return () => {
        window.removeEventListener("resize", onScrollOrResize);
        window.removeEventListener("scroll", onScrollOrResize, true);
      };
    }, [open]);

    // API: server-side search only
    const fetchGroups = async (q = "") => {
      if (!projectId) return;
      try {
        setLoading(true);
        setError("");
        const res = await axiosInstance.get(`${API_URL}/get_equipment_group`, {
          params: { project_selected: projectId, search: q },
        });
        const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
        setOptions(rows.map((r) => r?.group_name).filter(Boolean));
      } catch (err) {
        console.error(
          "equipment group fetch failed:",
          err?.response?.data || err?.message,
        );
        setError("Failed to load equipment names");
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    // initial load on open + when project changes
    useEffect(() => {
      if (open) fetchGroups("");
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, projectId]);

    // debounced server search
    useEffect(() => {
      if (!open) return;
      if (searchDebounce.current) clearTimeout(searchDebounce.current);
      searchDebounce.current = setTimeout(() => fetchGroups(search), 300);
      return () => clearTimeout(searchDebounce.current);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const toggle = (val) => {
      if (!val) return;
      if (selected.includes(val)) onChange(selected.filter((s) => s !== val));
      else onChange([...selected, val]);
    };

    const clearAll = () => onChange([]);
    const selectAllVisible = () => {
      const merged = Array.from(new Set([...selected, ...options]));
      onChange(merged);
    };

    const menu = (
      <div
        ref={menuRef}
        className="dropdown-menu show p-2 shadow equipment-dropdown-portal"
        style={{
          position: "fixed",
          top: menuPos.top,
          left: menuPos.left,
          width: "210px !important",
          maxHeight: menuPos.maxH,
          overflow: "auto",
          zIndex: 2000,
        }}
        role="listbox"
        aria-label="Equipment name menu"
      >
        <div className="mb-2">
          <input
            className="form-control form-control-sm"
            placeholder="Search equipment name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
        </div>

        <div className="d-flex justify-content-between mb-2">
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={clearAll}
          >
            Clear
          </button>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={selectAllVisible}
            disabled={options.length === 0}
          >
            Select All
          </button>
        </div>

        {loading && <div className="small text-muted px-1">Loading…</div>}
        {error && <div className="text-danger small px-1">{error}</div>}
        {!loading && !error && options.length === 0 && (
          <div className="small text-muted px-1">No results</div>
        )}

        <ul className="list-unstyled mb-0">
          {options.map((opt) => (
            <li key={opt} className="d-flex align-items-center py-1 px-1">
              <input
                id={`equip-${opt}`}
                type="checkbox"
                className="form-check-input me-2"
                checked={selected.includes(opt)}
                onChange={() => toggle(opt)}
              />
              <label
                className="form-check-label"
                htmlFor={`equip-${opt}`}
                style={{ cursor: "pointer" }}
              >
                {opt}
              </label>
            </li>
          ))}
        </ul>

        {/* {selected.length > 0 && (
          <>
            <hr className="my-2" />
            <div className="d-flex flex-wrap gap-1">
              {selected.map((s) => (
                <span key={s} className="badge bg-secondary">
                  {s}
                  <button
                    type="button"
                    className="btn-close btn-close-white btn-sm ms-1"
                    aria-label="Remove"
                    onClick={() => toggle(s)}
                    style={{ transform: "scale(.7)" }}
                  />
                </span>
              ))}
            </div>
          </>
        )} */}
      </div>
    );

    return (
      <div className="equipment-name-dropdown">
        <button
          ref={btnRef}
          type="button"
          className="btn btn-outline-secondary d-flex align-items-center gap-2"
          onClick={() => setOpen((o) => !o)}
          disabled={disabled || !projectId}
          style={{
            minWidth: 140,
            backgroundColor: "#fff",
            border: "1px solid #cbd5e1",
            color: "#334155",
          }}
        >
          Equipment Name
          {selected.length > 0 && (
            <span className="badge bg-primary rounded-pill ms-3">
              {selected.length}
            </span>
          )}
          <span className="ms-auto">
            <IoChevronDown />
          </span>
        </button>
        {selected.length > 0 && (
          <button
            type="button"
            className="filter-quick-clear"
            aria-label={`Clear ${selected.length} selected equipment name filter${selected.length === 1 ? "" : "s"}`}
            title="Clear equipment name filter"
            onClick={() => {
              clearAll();
              setOpen(false);
            }}
            disabled={disabled}
          >
            <CloseIcon fontSize="inherit" />
          </button>
        )}

        {open && createPortal(menu, document.body)}
      </div>
    );
  };

  const EquipmentNumberDropdown = ({
    projectId,
    selected = [],
    onChange,
    disabled = false,
  }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [error, setError] = useState("");

    const btnRef = useRef(null);
    const menuRef = useRef(null);
    const searchDebounce = useRef(null);
    const hasInitiallyFetched = useRef(false);
    const [menuPos, setMenuPos] = useState({
      top: 0,
      left: 100,
      width: 200,
      maxH: 320,
    });

    const computeMenuPos = () => {
      if (!btnRef.current) return;
      const r = btnRef.current.getBoundingClientRect();
      const desiredW = 100,
        desiredH = 320,
        gutter = 8;
      const left = Math.min(
        Math.max(gutter, r.left),
        window.innerWidth - desiredW - gutter,
      );
      const spaceBelow = window.innerHeight - r.bottom - gutter;
      const spaceAbove = r.top - gutter;
      let top = r.bottom + 6;
      let maxH = Math.min(desiredH, spaceBelow);
      if (spaceBelow < Math.min(200, desiredH) && spaceAbove > spaceBelow) {
        maxH = Math.min(desiredH, spaceAbove);
        top = Math.max(gutter, r.top - maxH - 6);
      }
      setMenuPos({ top, left, width: desiredW, maxH });
    };

    useEffect(() => {
      const handler = (e) => {
        if (!open) return;
        if (
          menuRef.current?.contains(e.target) ||
          btnRef.current?.contains(e.target)
        )
          return;
        setOpen(false);
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, [open]);

    useEffect(() => {
      if (!open) return;
      computeMenuPos();
      const onScrollOrResize = () => computeMenuPos();
      window.addEventListener("resize", onScrollOrResize);
      window.addEventListener("scroll", onScrollOrResize, true);
      return () => {
        window.removeEventListener("resize", onScrollOrResize);
        window.removeEventListener("scroll", onScrollOrResize, true);
      };
    }, [open]);

    const fetchNumbers = async (q = "") => {
      if (!projectId) return;
      try {
        setLoading(true);
        setError("");
        const res = await axiosInstance.get(
          `${API_URL}/get_all_equipment_number`,
          {
            params: { project_selected: projectId, search: q },
          },
        );
        const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
        // tolerate different shapes: "equipment_number", "no", or string
        const opts = rows
          .map((r) => r?.equipment_number ?? r?.no ?? r)
          .filter(Boolean);
        setOptions(opts);
      } catch (err) {
        console.error(
          "equipment number fetch failed:",
          err?.response?.data || err?.message,
        );
        setError("Failed to load equipment numbers");
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      if (open && !hasInitiallyFetched.current) {
        fetchNumbers("");
        hasInitiallyFetched.current = true;
      }
      // Reset flag when dropdown closes
      if (!open) {
        hasInitiallyFetched.current = false;
      }
    }, [open, projectId]); // eslint-disable-line

    // Only fetch on search change (debounced)
    useEffect(() => {
      if (!open) return;
      // Don't fetch on initial empty search since we already fetched above
      if (search === "" && !hasInitiallyFetched.current) return;

      if (searchDebounce.current) clearTimeout(searchDebounce.current);
      searchDebounce.current = setTimeout(() => fetchNumbers(search), 300);
      return () => clearTimeout(searchDebounce.current);
    }, [search]); //

    const toggle = (val) => {
      if (!val) return;
      onChange(
        selected.includes(val)
          ? selected.filter((s) => s !== val)
          : [...selected, val],
      );
    };
    const clearAll = () => onChange([]);
    const selectAllVisible = () =>
      onChange(Array.from(new Set([...selected, ...options])));

    const menu = (
      <div
        ref={menuRef}
        className="dropdown-menu show p-2 shadow equipment-dropdown-portal"
        style={{
          position: "fixed",
          top: menuPos.top,
          left: menuPos.left,
          width: "272px !important",
          maxHeight: menuPos.maxH,
          overflow: "auto",
          zIndex: 2000,
        }}
        role="listbox"
        aria-label="Equipment number menu"
      >
        <div className="mb-2">
          <input
            className="form-control form-control-sm"
            placeholder="Search equip/tag number..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
        </div>

        <div className="d-flex justify-content-between mb-2">
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={clearAll}
          >
            Clear
          </button>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={selectAllVisible}
            disabled={options.length === 0}
          >
            Select All
          </button>
        </div>

        {loading && <div className="small text-muted px-1">Loading…</div>}
        {error && <div className="text-danger small px-1">{error}</div>}
        {!loading && !error && options.length === 0 && (
          <div className="small text-muted px-1">No results</div>
        )}

        <ul className="list-unstyled mb-0">
          {options.map((opt) => (
            <li key={opt} className="d-flex align-items-center py-1 px-1">
              <input
                id={`equipno-${opt}`}
                type="checkbox"
                className="form-check-input me-2"
                checked={selected.includes(opt)}
                onChange={() => toggle(opt)}
              />
              <label
                className="form-check-label"
                htmlFor={`equipno-${opt}`}
                style={{ cursor: "pointer" }}
              >
                {opt}
              </label>
            </li>
          ))}
        </ul>

        {/* {selected.length > 0 && (
          <>
            <hr className="my-2" />
            <div className="d-flex flex-wrap gap-1">
              {selected.map((s) => (
                <span key={s} className="badge bg-secondary">
                  {s}
                  <button
                    type="button"
                    className="btn-close btn-close-white btn-sm ms-1"
                    aria-label="Remove"
                    onClick={() => toggle(s)}
                    style={{ transform: "scale(.7)" }}
                  />
                </span>
              ))}
            </div>
          </>
        )} */}
      </div>
    );

    return (
      <div className="equipment-number-dropdown">
        <button
          ref={btnRef}
          type="button"
          className="btn btn-outline-secondary d-flex align-items-center gap-2"
          onClick={() => setOpen((o) => !o)}
          disabled={disabled || !projectId}
          style={{
            minWidth: 140,
            backgroundColor: "#fff",
            border: "1px solid #cbd5e1",
            color: "#334155",
          }}
        >
          Equipment No. / Tag No.
          {selected.length > 0 && (
            <span className="badge bg-primary rounded-pill ms-3">
              {selected.length}
            </span>
          )}
          <span className="ms-auto">
            <IoChevronDown />
          </span>
        </button>
        {selected.length > 0 && (
          <button
            type="button"
            className="filter-quick-clear"
            aria-label={`Clear ${selected.length} selected equipment number filter${selected.length === 1 ? "" : "s"}`}
            title="Clear equipment number filter"
            onClick={() => {
              clearAll();
              setOpen(false);
            }}
            disabled={disabled}
          >
            <CloseIcon fontSize="inherit" />
          </button>
        )}

        {open && createPortal(menu, document.body)}
      </div>
    );
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedStatuses, selectedEquipNames, selectedEquipNumbers]);

  // useEffect(() => {
  //   setSelectedStatuses([]);
  //   setSelectedEquipNames([]);
  //   setSelectedEquipNumbers([]); // ← add this
  //   setSelectedFlanges([]);
  //   setCurrentPage(1);
  // }, [selectedProject?.id ?? selectedProject]);

  useEffect(() => {
    setSelectedFlanges([]);
  }, [selectedProject?.id ?? selectedProject]);

  // 2. Restore filter state on mount (runs once)
  useEffect(() => {
    const currentProject =
      JSON.parse(localStorage.getItem("selectedProject")) || [];
    setSelectedProject(currentProject);

    try {
      const savedRaw = sessionStorage.getItem(ALL_FLANGES_LIST_STATE_KEY);
      if (!savedRaw) return;

      const saved = JSON.parse(savedRaw);
      const currentProjectId = currentProject?.id || currentProject;

      if (
        String(saved?.projectId || "") &&
        String(saved?.projectId || "") !== String(currentProjectId || "")
      ) {
        return;
      }

      if (typeof saved?.searchQuery === "string") {
        skipNextSearchPageResetRef.current = true;
        setSearchQuery(saved.searchQuery);
      }
      if (Array.isArray(saved?.selectedStatuses)) {
        setSelectedStatuses(saved.selectedStatuses);
      }
      if (Array.isArray(saved?.selectedEquipNames)) {
        setSelectedEquipNames(saved.selectedEquipNames);
      }
      if (Array.isArray(saved?.selectedEquipNumbers)) {
        setSelectedEquipNumbers(saved.selectedEquipNumbers);
      }
      if (typeof saved?.activeTab === "string") {
        setActiveTab(saved.activeTab);
      }
      if (Number.isFinite(saved?.currentPage) && saved.currentPage > 0) {
        setCurrentPage(saved.currentPage);
      }
      if (Number.isFinite(saved?.itemsPerPage) && saved.itemsPerPage > 0) {
        setItemsPerPage(saved.itemsPerPage);
      }

      lastProjectRef.current = String(currentProjectId || "");
    } catch (err) {
      console.error("Failed to restore all-flanges list state:", err);
    }
  }, []); // runs once on mount only

  // Links from dashboards can prefill the list search without requesting a
  // row-scroll target. Keep this separate from the legacy scrollTo workflow.
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const flangeNumber = String(
      searchParams.get("flangeNumber") || searchParams.get("flange_number") || "",
    ).trim();

    if (!flangeNumber) return;

    skipNextSearchPageResetRef.current = true;
    setSearchQuery(flangeNumber);
    setActiveTab("All Flanges");
    setSelectedStatuses([]);
    setSelectedEquipNames([]);
    setSelectedEquipNumbers([]);
    setCurrentPage(1);
  }, [location.search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const scrollTarget = String(searchParams.get("scrollTo") || "").trim();
    const flangeNumber = String(
      searchParams.get("flangeNumber") || searchParams.get("flange_number") || "",
    ).trim();

    if (!scrollTarget || !flangeNumber) return;

    handledScrollTargetsRef.current.delete(scrollTarget);
    skipNextSearchPageResetRef.current = true;

    if (activeTab !== "All Flanges") {
      setActiveTab("All Flanges");
    }
    if (searchQuery.trim() !== flangeNumber) {
      setSearchQuery(flangeNumber);
    }
    if (selectedStatuses.length > 0) {
      setSelectedStatuses([]);
    }
    if (selectedEquipNames.length > 0) {
      setSelectedEquipNames([]);
    }
    if (selectedEquipNumbers.length > 0) {
      setSelectedEquipNumbers([]);
    }
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [
    activeTab,
    currentPage,
    location.search,
    searchQuery,
    selectedEquipNames,
    selectedEquipNumbers,
    selectedStatuses,
  ]);

  // 3. Reset filters when project changes, save state on every filter change
  useEffect(() => {
    const currentProjectId = String(
      selectedProject?.id || selectedProject || "",
    );
    if (!currentProjectId) return;

    if (!lastProjectRef.current) {
      lastProjectRef.current = currentProjectId;
    } else if (lastProjectRef.current !== currentProjectId) {
      // Project actually changed — clear everything
      sessionStorage.removeItem(ALL_FLANGES_LIST_STATE_KEY);
      skipNextSearchPageResetRef.current = false;
      setSearchQuery("");
      setSelectedStatuses([]);
      setSelectedEquipNames([]);
      setSelectedEquipNumbers([]);
      setActiveTab("All Flanges");
      setCurrentPage(1);
      setItemsPerPage(50);
      lastProjectRef.current = currentProjectId;
      return; // don't save snapshot yet on reset
    }

    // Save current state snapshot
    const snapshot = {
      projectId: currentProjectId,
      searchQuery,
      selectedStatuses,
      selectedEquipNames,
      selectedEquipNumbers,
      activeTab,
      currentPage,
      itemsPerPage,
    };
    sessionStorage.setItem(
      ALL_FLANGES_LIST_STATE_KEY,
      JSON.stringify(snapshot),
    );
  }, [
    selectedProject,
    searchQuery,
    selectedStatuses,
    selectedEquipNames,
    selectedEquipNumbers,
    activeTab,
    currentPage,
    itemsPerPage,
  ]);

  const handleSubmitTicket = async () => {
    if (!selectedFlangeId) {
      toast.error("Flange ID is missing");
      return;
    }
    const ticketTitle = ticketTitleRef.current;
    const ticketDescription = ticketDescriptionRef.current;
    if (!ticketTitle.trim() || !ticketType || !ticketPriority) {
      toast.error("Title, ticket type, and priority are required");
      return;
    }

    const formData = new FormData();
    formData.append("entity_type", "flange");
    formData.append("flange_id", selectedFlangeId);
    formData.append("title", ticketTitle.trim());
    formData.append("description", ticketDescription);
    formData.append("ticket_type", ticketType);
    formData.append("priority", ticketPriority);
    ticketAssigneeUsers.forEach((user) =>
      formData.append("assignee_user_ids", user.id),
    );
    ticketAssigneeDepartments.forEach((dept) =>
      formData.append("assignee_department_ids", dept.id),
    );
    ticketAttachments.forEach((file) => formData.append("attachments", file));

    setLoading(true);
    try {
      // ✅ axiosInstance will attach Authorization automatically
      const response = await axiosInstance.post(
        `${API_URL}/api/ticket/v2`,
        formData,
      );

      const data = response.data || {};
      console.log("Ticket API Response:", data);

      toast.success(data.message || "Ticket created successfully");
      (data.warnings || []).forEach((warning) => {
        if (warning?.message) toast.warning(warning.message);
      });
      handleCloseTicketModal();
    } catch (error) {
      const msg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to create ticket";
      toast.error(msg);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchWarningTypes = async () => {
      try {
        const response = await axiosInstance.get(
          `${API_URL}/api/get_all_error_codes`,
        );

        if (response.status === 200 && Array.isArray(response.data.data)) {
          const types = response.data.data.map((item) => ({
            code: item.code,
            label: `${item.code} - ${item.description}`,
          }));
          setWarningTypes(types);
        } else {
          console.error("Unexpected response format:", response);
        }
      } catch (error) {
        console.error("Error fetching warning types:", error);
      }
    };

    fetchWarningTypes();
  }, []);

  const fetchSearchUsers = async (query, page = 1) => {
    try {
      const res = await axiosInstance.get(`${API_URL}/api/search_flange`, {
        params: { query, page, Items_per_page: itemsPerPage },
      });

      const { Total_records } = res.data;
      setFlanges(res.data.data || []);

      setTotalRecords(Total_records || 0);
    } catch (err) {
      console.error("Search fetch failed:", err.response?.data || err.message);
    }
  };

  useEffect(() => {
    const fetchEquipment = async () => {
      try {
        const response = await axiosInstance.get("get_all_equipment_number", {
          params: {
            project_selected: selectedProject,
          },
        });

        if (response.status === 200 && Array.isArray(response.data.data)) {
          setUniqueEquipmentWar(response.data.data); // assuming data has {no, name}
        }
      } catch (error) {
        console.error("Failed to fetch equipment:", error);
      }
    };

    if (isWarningModalOpen) {
      fetchEquipment();
    }
  }, [isWarningModalOpen]);

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (nameFilterTimeoutRef.current)
        clearTimeout(nameFilterTimeoutRef.current);
      if (tagFilterTimeoutRef.current)
        clearTimeout(tagFilterTimeoutRef.current);
    };
  }, []);

  // const affectedFlanges = selectedFlanges.filter((f) => {
  //   if (ignoreScope === "project") {
  //     return !selectedWarningType || f.warningType === selectedWarningType;
  //   }
  //   return selectedEquipment.includes(f.equipmentNo) && (!selectedWarningType || f.warningType === selectedWarningType);
  // });

  const submitArchiveUnarchive = async () => {
    if (!auTargetId) {
      toast.error("Missing flange id");
      return;
    }

    if (!auRemark.trim()) {
      toast.info("Please enter a remark.");
      return;
    }

    try {
      setAuSubmitting(true);

      const path =
        auAction === "archive" ? "delete_from_scope" : "activate_in_scope";
      const url = `${API_URL}/api/flange/${path}/${auTargetId}`;

      const fd = new FormData();
      fd.append("remark", auRemark.trim());

      // ✅ axiosInstance handles Authorization automatically
      const res = await axiosInstance.post(url, fd);

      const data = res.data || {};

      toast.success(
        data?.message ||
          (auAction === "archive"
            ? "Flange deleted from scope successfully."
            : "Flange activated successfully."),
      );

      setArchivedMap((prev) => ({
        ...prev,
        [auTargetId]: auAction === "archive",
      }));

      setAuOpen(false);
      setAuRemark("");
      setAuTargetId(null);

      window.dispatchEvent(new Event("flangeUpdated"));
    } catch (e) {
      const msg =
        e?.response?.data?.error ||
        e?.response?.data?.message ||
        "Request failed";
      toast.error(msg);
      console.error(e);
    } finally {
      setAuSubmitting(false);
    }
  };

  const resetWarningModalStates = () => {
    setSelectedWarningType([]);
    setIgnoreScope("equipment_name");
    setSelectedEquipmentName("");
    setSelectedEquipmentNumbers([]);
    setSelectedEquipment([]);
    setReason("");
  };

  // Then modify the modal close handler
  const handleCloseWarningModal = () => {
    resetWarningModalStates();
    setIsWarningModalOpen(false);
  };

  const handleIgnoreWarning = async () => {
    if (!selectedWarningType.length === 0) {
      toast.info("Please select warning type and provide a reason.");
      return;
    }

    // Basic validations
    if (
      (ignoreScope === "equipment_name" &&
        selectedEquipmentName.length === 0) ||
      (ignoreScope === "equipment_number" &&
        selectedEquipmentNumbers.length === 0)
    ) {
      toast.info("Please select equipment.");
      return;
    }

    let payload = {};

    if (ignoreScope === "project") {
      payload = {
        selected_type: "Project_level",
        codes: selectedWarningType,
        project_selected: selectedProject,
      };
    } else if (ignoreScope === "equipment_name") {
      payload = {
        selected_type: "Equipment_level",
        codes: selectedWarningType,
        selected_equipment: selectedEquipmentName,
        project_selected: selectedProject,
      };
    } else if (ignoreScope === "equipment_number") {
      payload = {
        selected_type: "Equipment_number",
        codes: selectedWarningType,
        selected_numbers: selectedEquipmentNumbers,
        project_selected: selectedProject,
      };
    }

    try {
      const response = await axiosInstance.post(
        "/api/avoid_flange_warnings",
        payload,
      );

      if (response.status === 200) {
        toast.success("Warnings successfully ignored.");
        handleCloseWarningModal();
        setSelectedWarningType([]);
        setReason("");
        setIgnoreScope("equipment_name");
        setSelectedEquipment([]);
        setSelectedEquipmentName([]);
        setSelectedEquipmentNumbers([]);
        window.dispatchEvent(new Event("flangeUpdated"));
        // Refresh the flange list
      } else {
        toast.error("Failed to ignore warnings.");
      }
    } catch (error) {
      console.error("Error ignoring warnings:", error);
      toast.error("An error occurred while ignoring warnings.");
    }
  };

  const handleViewClick = (flangeId) => {
    setSelectedFlangeId(flangeId);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedFlangeId(null);
  };

  const handleWarningClick = (flange) => {
    setSelectedFlange(flange);
    setSelectedWarnings([]);
    setShowWarningModal(true);
  };

  const toggleWarningSelection = (code) => {
    if (!code || code === "undefined") return;

    setSelectedWarnings((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code],
    );
  };

  const handleAvoidWarnings = async () => {
    const validWarnings = selectedWarnings;

    if (validWarnings.length === 0) {
      toast.info("Please select at least one warning.");
      return;
    }

    // if (!avoidReason.trim()) {
    //   alert("Please provide a reason for avoiding the warning(s).");
    //   return;
    // }

    try {
      await axiosInstance.post("/api/avoid_flange_warnings", {
        selected_type: "Specific Flange Level",
        codes: validWarnings,
        flange_ids: [selectedFlange.flange_id],
        project_selected: selectedProject,
        // reason: avoidReason,
      });

      setShowWarningModal(false);
      setAvoidReason("");
      window.dispatchEvent(new Event("flangeUpdated"));
    } catch (err) {
      console.error("Error avoiding warnings:", err);
      toast.error("Failed to avoid warnings.");
    }
  };

  const handleCertificatePrint = async (overrideFlangeIds = null) => {
    if (tagPrintPreparing) return;

    const ids = Array.isArray(overrideFlangeIds)
      ? overrideFlangeIds
      : selectedFlanges.map((f) => f.flange_id);

    if (!ids.length) {
      toast.error("No flanges selected to print.");
      return;
    }

    let styleEl = null;
    const printContainers = [];

    try {
      setTagPrintPreparing(true);

      const response = await axiosInstance.post("/api/print_tag", {
        flange_ids: ids,
      });

      const result = response.data;

      if (!result.data || !Array.isArray(result.data) || !result.data.length) {
        toast.error("Failed to fetch certificates.");
        return;
      }

      const certificates = result.data;

      const certHtmls = certificates.map((cert) => {
        return `
      <div class="certificate-container">
        <!-- FRONT -->
        <div class="tag-container">
          <div class="titles-jecon-certificate">
            <div>
              <h2 class="company-name">Jecon Engineers Pvt. Ltd.</h2>
              <h3 class="title">FLANGE TIGHTENED</h3>
            </div>
            <div>
              <div class="sticker-placeholder">
                <p class="sticker-font">For Sticker</p>
              </div>
            </div>
          </div>
          <div class="main-form">
            <div class="form-section">
              <div class="form-item">
                <label class="form-label">CERT#:</label>
                <input type="text" class="form-input input-certificate" value="${
                  cert.flange_number || ""
                }" />
              </div>
              <div class="form-item">
                <label class="form-label">SIGNED:</label>
                <input type="text" class="form-input input-certificate-2" value="" />
              </div>
              <div class="form-item">
                <label class="form-label">DATE:</label>
                <input type="text" class="form-input date-certificate " value="${new Date().toLocaleDateString()}" />
              </div>
            </div>
            <div class="qr-image">
              <img src="data:image/png;base64,${cert.qr_code}" alt="QR Code" />
            </div>
          </div>
        </div>

        <!-- BACK -->
        <div class="flange-tag-container">
          <div class="flange-tag">
            <div class="tag-row">
              <div class="tag-label">Equipment / Tag No.</div>
              <div class="tag-line"><div class="tag-value">${
                cert.equipment_number || ""
              }</div></div>
            </div>
            <div class="tag-title">Flange Joint Identification Tag</div>
            <div class="tag-row"><div class="tag-label">Equipment Name</div><div class="tag-line"><input value="${
              cert.equipment_name || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Flange Size</div><div class="tag-line"><input value="${
              cert.flange_size || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Flange Rating</div><div class="tag-line"><input value="${
              cert.rating || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Gasket Type</div><div class="tag-line"><input value="${
              cert.gasket_moc || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Stud / Nut MOC</div><div class="tag-line"><input value="${
              cert.stud_nut_moc || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Bolt Diameter</div><div class="tag-line"><input value="${
              cert.bolt_diameter || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Method of tightening</div><div class="tag-line"><input value="${
              cert.method_of_tightening || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Lubricant used</div><div class="tag-line"><input value="${
              cert.lubricant_used || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Torquing Type</div><div class="tag-line"><input value="${
              cert.torquing_type || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Required Torque</div><div class="tag-line"><input value="${
              cert.required_torque || ""
            }" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">Achieved Torque</div><div class="tag-line"><input value="" readonly /></div></div>
            <div class="tag-row"><div class="tag-label">QC Sign</div><div class="tag-line"><input value="" readonly /></div></div>
          </div>
        </div>

      </div>
    `;
      });

      // Shared print styles (injected once into <head>)
      styleEl = document.createElement("style");
      styleEl.textContent = `
/* ======= Front Side Certificate ======= */

.tag-container {
  width: 377.95px;
  height: 245.67px;
  background: linear-gradient(145deg, #b8b8b8, #e0e0e0);
  padding: 12px;
  margin-bottom: 12px;
  box-sizing: border-box;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.company-name, .title{
       text-align: left !important;
       margin-left: 10px;
}

.titles-jecon-certificate{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.bulkbtnAll-tg { display: flex; }
.impoleft { margin-left: 10px; }

.company-name {
  font-size: 14px;
  font-weight: bold;
  color: purple;
  text-align: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 9px;
}

.check-item {
  display: flex;
  align-items: center;
  margin-right: 8px;
  width: 50%;
  gap: 4px;
}

.equip-tag-no{
 margin-bottom: 2px;
}

.certificate-checked {
  appearance: none;
  width: 90px;
  height: 22px;
  border: 1.5px solid #2c2c2c;
  background-color: #fff;
  cursor: pointer;
  position: relative;
  display: inline-block;
}

.certificate-checked:checked {
  background-color: #003366;
  border-color: #003366;
}

.certificate-checked:checked::after {
  content: "✔";
  color: #fff;
  font-size: 14px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
}

.main-form {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;  /* Adds space between form and QR */
}


.sticker-placeholder {
  width: 118px;  /* Increased from 100% */
  height: auto;  /* Added fixed height */
  margin-right: 5px;
  background: transparent !important;
  border: 1px solid #595959ff;
  border-radius: 3px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
  
.sticker-placeholder .sticker-font {
  font-size: 8px !important;  /* Increased from 8px */
  color: #575757cc;
}

/* Also adjust the titles container to accommodate larger sticker */
.titles-jecon-certificate {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}
.form-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 4px;  /* Add space between label and input */
}

.form-label {
  font-size: 12px;
  font-weight: bold;
  min-width: 50px;  /* Fixed width for alignment */
  text-align: left;
  white-space: nowrap;
}

.form-input {
  font-size: 12px;
  background: transparent;
  border: none;
  border-bottom: 1px solid #000;
  outline: none;
  margin: 2px 0;
  padding: 2px 4px 0 4px;
  height: 25px;
  line-height: 1.2;
  vertical-align: middle;
  flex: 1;
  min-width: 140px;  /* Minimum width for inputs */
}

.form-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;  /* Increased gap between rows */
  width: 60%;
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
}

.main-form {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
  padding-top: 5px;
}

input.form-input.input-certificate,
input.form-input.input-certificate-2,
input.form-input.date-certificate {
  width: 100%;
  min-width: 140px;
}

.qr-image { 
  width: 120px !important;
  height: auto !important;
  min-height: 120px !important;
  margin-top: 30px;
  flex-shrink: 0;
} 

.qr-image img { 
  width: 100%; 
  height: 100% !important;
  object-fit: contain;
  display: block;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.page-break {
  page-break-after: always;
  break-after: page;
}

/* ======= Back Side Certificate ======= */

.flange-tag-container {
  transform: rotate(90deg);
  transform-origin: center;
  display: inline-block;
}

.flange-tag-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  font-family: Arial, sans-serif;
}

.flange-tag {
  position: relative;
  width: 245.67px;
  height: 377.95px;
  background: linear-gradient(145deg, #b8b8b8, #e0e0e0);
  border: 1px solid #333;
  padding: 6px;
  box-sizing: border-box;
  overflow: hidden;
}

.tag-hole {
  position: absolute;
  top: 3px;
  right: 4px;
  width: 15px;
  height: 13px;
  border-radius: 50%;
  background-color: #8b7355;
  border: 1px solid #333;
}

.tag-title {
  border: 1.5px solid #000;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 3px;
  background-color: transparent;
}

.tag-row {
  display: flex;
  margin-bottom:1px;
}

.tag-label {
  border: 1.5px solid #000;
  padding: 2px;
  font-size: 10px;
  font-weight: bold;
  background-color: transparent;
  margin-bottom: 0px;
  justify-content: flex-start;
  align-items: center;
  width: 50%;
  line-height: 1.2;
}

.tag-line {
  flex-grow: 1;
  margin-left: 8px;
  border-bottom: #000 solid 1px;
  align-items: center;
}

.tag-line input {
  width: 100%;
  color: black;
  border: none;
  background: transparent;
  font-size: 10px;
  outline: none;
   font-family: Arial, sans-serif;
  height: 20px;
  padding: 0;
}

.tag-value {
  width: 100%;
  font-size: 11px;
  font-family: Arial, sans-serif;
  padding: 1px 0;
}

.tag-label.tag-date {
  width: 24%;
}

.certificate-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.data-info {
  font-size: 14px;
  font-weight: 500;
  color: #555;
  text-align: right;
  margin-bottom: 10px;
}
`;
      document.head.appendChild(styleEl);

      // Render each certificate into its OWN off-screen page. html2canvas has a
      // maximum canvas size; one container holding many A4-tall tags overflows
      // that limit and renders blank pages. One tag per page keeps every canvas
      // small and reliable.
      certHtmls.forEach((html) => {
        const page = document.createElement("div");
        page.className = "flange-print-page";
        page.style.padding = "40px";
        page.style.background = "#ffffff";
        page.innerHTML = html;
        document.body.appendChild(page);
        printContainers.push(page);
      });

      const opt = {
        margin: 0.3,
        filename: "flange_certificates.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
        jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
      };

      // Merge the per-page canvases into a single multi-page PDF.
      let worker = html2pdf().set(opt).from(printContainers[0]).toPdf();
      for (let i = 1; i < printContainers.length; i++) {
        const page = printContainers[i];
        worker = worker
          .get("pdf")
          .then((pdf) => {
            pdf.addPage();
          })
          .set(opt)
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      }
      await worker.save();
    } catch (err) {
      console.error("Print Error:", err);
      toast.error("Error printing certificates.");
    } finally {
      printContainers.forEach((page) => page.remove());
      if (styleEl) styleEl.remove();
      setTagPrintPreparing(false);
    }
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const stored = localStorage.getItem("selectedProject");
      const updated = stored ? JSON.parse(stored) : null;
      setSelectedProject(updated);
    };

    window.addEventListener("projectChanged", handleStorageChange);

    return () => {
      window.removeEventListener("projectChanged", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    return () => {
      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
      }
      if (pulseTimeoutRef.current) {
        clearTimeout(pulseTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const scrollTargetRaw = searchParams.get("scrollTo");
    const scrollTarget = scrollTargetRaw
      ? decodeURIComponent(scrollTargetRaw).trim()
      : "";
    const flangeNumber = String(
      searchParams.get("flangeNumber") || searchParams.get("flange_number") || "",
    ).trim();

    if (
      scrollTarget &&
      flangeNumber &&
      (activeTab !== "All Flanges" ||
        searchQuery.trim() !== flangeNumber ||
        selectedStatuses.length > 0 ||
        selectedEquipNames.length > 0 ||
        selectedEquipNumbers.length > 0 ||
        currentPage !== 1)
    ) {
      return;
    }

    if (
      !scrollTarget ||
      activeTab !== "All Flanges" ||
      loading ||
      Flanges.length === 0
    ) {
      return;
    }

    if (handledScrollTargetsRef.current.has(scrollTarget)) {
      return;
    }

    const targetExistsInCurrentView = Flanges.some(
      (flange) =>
        String(flange?.flange_id ?? flange?.id ?? "").trim() === scrollTarget,
    );

    const clearScrollParam = () => {
      const nextParams = new URLSearchParams(location.search);
      nextParams.delete("scrollTo");
      nextParams.delete("flangeNumber");
      nextParams.delete("flange_number");
      const nextSearch = nextParams.toString();
      navigate(
        {
          pathname: location.pathname,
          search: nextSearch ? `?${nextSearch}` : "",
        },
        { replace: true },
      );
    };

    const finishWithNotFound = () => {
      handledScrollTargetsRef.current.add(scrollTarget);
      setSnackbarMessage(
        "Requested flange could not be found after searching by flange number.",
      );
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
      clearScrollParam();
    };

    if (!targetExistsInCurrentView) {
      finishWithNotFound();
      return;
    }

    const timer = setTimeout(() => {
      const targetRow = document.getElementById(`flange-row-${scrollTarget}`);

      if (!targetRow) {
        finishWithNotFound();
        return;
      }

      handledScrollTargetsRef.current.add(scrollTarget);
      targetRow.scrollIntoView({ behavior: "smooth", block: "center" });

      setHighlightedFlangeId(scrollTarget);
      setPulsedFlangeId(scrollTarget);

      if (pulseTimeoutRef.current) {
        clearTimeout(pulseTimeoutRef.current);
      }
      pulseTimeoutRef.current = setTimeout(() => {
        setPulsedFlangeId(null);
      }, 700);

      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
      }
      highlightTimeoutRef.current = setTimeout(() => {
        setHighlightedFlangeId(null);
      }, 2600);

      clearScrollParam();
    }, 120);

    return () => clearTimeout(timer);
  }, [
    activeTab,
    currentPage,
    Flanges,
    loading,
    location.pathname,
    location.search,
    navigate,
    searchQuery,
    selectedEquipNames,
    selectedEquipNumbers,
    selectedStatuses,
  ]);

  const fetchCalls = async () => {
    const projectParam = selectedProject?.id || selectedProject;
    if (!projectParam) {
      setFlanges([]);
      setTotalRecords(0);
      return;
    }
    if (isInitialLoad.current) {
      setPageLoading(true);
    }
    setLoading(true);
    try {
      const params = {
        project_selected: projectParam,
        page: currentPage,
        per_page: itemsPerPage,
        active_tab: activeTab,
        ...(selectedStatuses.length ? { status: selectedStatuses } : {}),
        ...(selectedEquipNames.length
          ? { equipment_name: selectedEquipNames }
          : {}),
        ...(selectedEquipNumbers.length
          ? { equipment_number: selectedEquipNumbers }
          : {}),
        ...(searchQuery?.trim() ? { query: searchQuery.trim() } : {}), // ✅ <-- HERE
      };

      const response = await axiosInstance.get("/api/get_all_flanges", {
        params,
        paramsSerializer: (p) => {
          const usp = new URLSearchParams();
          Object.entries(p).forEach(([k, v]) => {
            if (Array.isArray(v)) v.forEach((item) => usp.append(k, item));
            else if (v !== undefined && v !== null && v !== "")
              usp.append(k, v);
          });
          return usp.toString();
        },
      });
      const { data, total_records } = response.data || {};
      setFlanges(Array.isArray(data) ? data : []);
      if (!data.length) {
        setErrorMessage(response.data.message || "No flanges found.");
      }
      setTotalRecords(Number.isFinite(total_records) ? total_records : 0);
    } catch (err) {
      console.error(
        "Error fetching flanges:",
        err.response?.data || err.message,
      );
    } finally {
      if (isInitialLoad.current) {
        setPageLoading(false);
        isInitialLoad.current = false;
      }
      setLoading(false);
    }
  };

  // ✅ useEffect only calls fetchCalls now
  useEffect(() => {
    // Debounced single-shot fetch; cleanup cancels the previous one.
    // In React 18 StrictMode, the first effect’s timer is cleaned up,
    // so only the second run fires => one network call.
    const t = setTimeout(fetchCalls, 0); // keep async tick, remove UX delay

    const handleFlangeUpdate = () => {
      clearTimeout(t);
      fetchCalls();
    };
    window.addEventListener("flangeUpdated", handleFlangeUpdate);

    return () => {
      clearTimeout(t);
      window.removeEventListener("flangeUpdated", handleFlangeUpdate);
    };
  }, [
    selectedProject,
    currentPage,
    itemsPerPage,
    activeTab,
    selectedStatuses,
    selectedEquipNames,
    selectedEquipNumbers,
    searchQuery,
  ]);

  const getStatusClass = (status, processName) => {
    const raw = (status ?? processName ?? "").toString().trim().toLowerCase();

    if (!raw) return "status-gray";

    switch (raw) {
      // Blinding - Blue
      case "blue":
      case "blinded":
      case "flange blinding":
        return "status-blue";

      // Deblinding - Red
      case "red":
      case "deblinded":
      case "flange deblinding":
        return "status-red";

      // Tightening - Yellow
      case "yellow":
      case "tightened":
      case "flange tightening":
      case "flange tightend": // ✅ Add this typo variant
        return "status-yellow";

      // Testing - Green
      case "green":
      case "tested":
      case "flange testing":
      case "flange tested":
        return "status-green";

      // Retesting/Retightening - Orange
      case "orange":
      case "flange retesting":
      case "flange retightening":
      case "retested":
      case "retightened":
        return "status-orange";

      // Client Approval - Purple
      case "purple":
      case "client approval":
      case "approved":
        return "status-purple";

      // Not Started - Gray
      case "not started":
      case "pending":
        return "status-gray";

      // Failed/Closed - Red
      case "closed":
      case "failed":
        return "status-red";

      default:
        return "status-gray";
    }
  };
  const handleHistory = (historyId) => {
    navigate(`/Flange_history/${historyId}`);
  };
  // const handleViewClick = (flange_id) => {
  //   navigate(`/view-tag-info/${flange_id}`);
  // };

  const handleEditClick = (flange_id) => {
    navigate(`/EditFlanges/${flange_id}`);
  };

  const downloadQrCodeForFlange = async (flange) => {
    if (!flange || !flange.flange_id) {
      throw new Error("Flange ID not found");
    }

    const response = await axiosInstance.post(
      `${API_URL}/api/download_qr_code/${flange.flange_id}`,
    );

    return response?.data;
  };

  const handleViewQRCode = async (flange) => {
    setTagPreviewLoading(true);
    setSelectedFlange(null);
    setShowQRModal(true);
    try {
      // Keep QR action API behavior aligned with existing QR flow.
      await downloadQrCodeForFlange(flange);

      const response = await axiosInstance.post("/api/print_tag", {
        flange_ids: [flange.flange_id],
      });
      const cert = response?.data?.data?.[0];
      setSelectedFlange(cert ? { ...flange, ...cert } : flange);
    } catch (error) {
      console.error("Error loading tag preview:", error);
      setSelectedFlange(flange);
      toast.error("Failed to load tag preview. Showing available data.");
    } finally {
      setTagPreviewLoading(false);
    }
  };


  const handlePrintSelectedTag = async () => {
    if (!selectedFlange || tagPrintPreparing) return;

    try {
      setTagPrintPreparing(true);

      const qrResponse = await downloadQrCodeForFlange(selectedFlange);

      // If download API returns updated data, merge before printing.
      if (qrResponse && typeof qrResponse === "object") {
        setSelectedFlange((prev) => ({
          ...(prev || {}),
          ...qrResponse,
        }));
      }

      await handleCertificatePrint([selectedFlange.flange_id]);
    } catch (error) {
      console.error("Error preparing tag print:", error);
      toast.error(
        error?.response?.data?.error ||
          "Unable to generate QR tag. Please try again.",
      );
    } finally {
      setTagPrintPreparing(false);
    }
  };

  const FlangeTagContent = ({ flange }) => {
    if (!flange) return null;
    return (
      <div className="flange-tag-content">
        <div className="flange-tag-front tag-container">
          <div className="titles-jecon-certificate">
            <div>
              <h2 className="company-name">Jecon Engineers Pvt. Ltd.</h2>
              <h3 className="title">FLANGE TIGHTENED</h3>
            </div>
            <div>
              <div className="sticker-placeholder">
                <p className="sticker-font">For Sticker</p>
              </div>
            </div>
          </div>
          <div className="main-form">
            <div className="ftp-form-section">
              <div className="ftp-form-item">
                <label className="ftp-form-label">CERT#:</label>
                <input
                  type="text"
                  className="ftp-form-input input-certificate"
                  value={flange.flange_number || ""}
                  readOnly
                />
              </div>
              <div className="ftp-form-item">
                <label className="ftp-form-label">SIGNED:</label>
                <input
                  type="text"
                  className="ftp-form-input input-certificate-2"
                  value=""
                  readOnly
                />
              </div>
              <div className="ftp-form-item">
                <label className="ftp-form-label">DATE:</label>
                <input
                  type="text"
                  className="ftp-form-input date-certificate"
                  value={new Date().toLocaleDateString()}
                  readOnly
                />
              </div>
            </div>
            <div className="qr-image">
              <img
                src={`data:image/png;base64,${flange.qr_code || ""}`}
                alt="QR Code"
              />
            </div>
          </div>
        </div>

        <div className="flange-tag-preview-back">
          <div className="flange-tag">
            <div className="tag-row">
              <div className="tag-label">Equipment / Tag No.</div>
              <div className="tag-line">
                <div className="tag-value">{flange.equipment_number || ""}</div>
              </div>
            </div>
            <div className="tag-title">Flange Joint Identification Tag</div>
            <div className="tag-row">
              <div className="tag-label">Equipment Name</div>
              <div className="tag-line">
                <input value={flange.equipment_name || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Flange Size</div>
              <div className="tag-line">
                <input value={flange.flange_size || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Flange Rating</div>
              <div className="tag-line">
                <input value={flange.rating || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Gasket Type</div>
              <div className="tag-line">
                <input value={flange.gasket_moc || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Stud / Nut MOC</div>
              <div className="tag-line">
                <input value={flange.stud_nut_moc || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Bolt Diameter</div>
              <div className="tag-line">
                <input value={flange.bolt_diameter || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Method of tightening</div>
              <div className="tag-line">
                <input value={flange.method_of_tightening || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Lubricant used</div>
              <div className="tag-line">
                <input value={flange.lubricant_used || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Torquing Type</div>
              <div className="tag-line">
                <input value={flange.torquing_type || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Required Torque</div>
              <div className="tag-line">
                <input value={flange.required_torque || ""} readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">Achieved Torque</div>
              <div className="tag-line">
                <input value="" readOnly />
              </div>
            </div>
            <div className="tag-row">
              <div className="tag-label">QC Sign</div>
              <div className="tag-line">
                <input value="" readOnly />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // const getFilteredFlanges = () => {
  //   return Flanges.filter((flange) => {
  //     const matchesEquipmentName =
  //       !equipmentNameFilter || flange.equipment_name === equipmentNameFilter;
  //     const matchesEquipmentTag =
  //       !equipmentTagFilter || flange.equipment_number === equipmentTagFilter;
  //     return matchesEquipmentName && matchesEquipmentTag;
  //   });
  // };

  const handleNewFlangeClick = () => {
    navigate("/create-flange");
  };

  // Server-side generation of tags for EVERY flange matching the current
  // filters (not just the visible page). Client-side html2pdf can't scale to a
  // whole project, so the backend renders the PDF and we download the blob.
  const handlePrintAllTags = async () => {
    if (printingAllTags) return;

    const projectId = selectedProject?.id || selectedProject;
    if (!projectId) {
      toast.error("Select a project first.");
      return;
    }

    setPrintingAllTags(true);
    try {
      const params = {
        ...(selectedStatuses.length ? { status: selectedStatuses } : {}),
        ...(selectedEquipNames.length
          ? { equipment_name: selectedEquipNames }
          : {}),
        ...(selectedEquipNumbers.length
          ? { equipment_number: selectedEquipNumbers }
          : {}),
        ...(searchQuery?.trim() ? { query: searchQuery.trim() } : {}),
      };

      const response = await axiosInstance.get(
        `${API_URL}/api/print_all_tags/${projectId}`,
        {
          params,
          paramsSerializer: (p) => {
            const usp = new URLSearchParams();
            Object.entries(p).forEach(([k, v]) => {
              if (Array.isArray(v)) v.forEach((item) => usp.append(k, item));
              else if (v !== undefined && v !== null && v !== "")
                usp.append(k, v);
            });
            return usp.toString();
          },
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "flange_tags.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Print all tags error:", err);
      // The server sends JSON errors even on the blob endpoint; surface them.
      let message = "Unable to generate tags PDF. Please try again.";
      try {
        if (err?.response?.data instanceof Blob) {
          const text = await err.response.data.text();
          const parsed = JSON.parse(text);
          if (parsed?.message) message = parsed.message;
        }
      } catch (_) {
        /* keep the default message */
      }
      toast.error(message);
    } finally {
      setPrintingAllTags(false);
    }
  };

  const handleExport = async () => {
    // Show initial loading snackbar
    setSnackbarMessage("Please wait, file is exporting...");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
    setLoading(true);

    try {
      const projectId = selectedProject?.id || selectedProject;
      if (!projectId) {
        setSnackbarOpen(false);
        setTimeout(() => {
          setSnackbarMessage("Select a project first.");
          setSnackbarSeverity("info");
          setSnackbarOpen(true);
        }, 300);
        setLoading(false);
        return;
      }

      // Only send filters + search
      const params = {
        ...(selectedStatuses.length ? { status: selectedStatuses } : {}),
        ...(selectedEquipNames.length
          ? { equipment_name: selectedEquipNames }
          : {}),
        ...(selectedEquipNumbers.length
          ? { equipment_number: selectedEquipNumbers }
          : {}),
        ...(searchQuery?.trim() ? { query: searchQuery.trim() } : {}),
      };
      try {
        const response = await axiosInstance.get(
          `${API_URL}/api/export_flange/${projectId}`,
          {
            params,
            paramsSerializer: (p) => {
              const usp = new URLSearchParams();
              Object.entries(p).forEach(([k, v]) => {
                if (Array.isArray(v)) v.forEach((item) => usp.append(k, item));
                else if (v !== undefined && v !== null && v !== "")
                  usp.append(k, v);
              });
              return usp.toString();
            },
            responseType: "blob",
          },
        );
        // Update snackbar message
        setSnackbarMessage("Preparing download...");
        setSnackbarSeverity("info");

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `flanges_export_${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`;

        // Wait for download to trigger
        document.body.appendChild(link);
        link.click();

        // Small delay to ensure download starts before cleanup
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          // Close current snackbar and show success
          setSnackbarOpen(false);
          setTimeout(() => {
            setSnackbarMessage("Export completed successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
          }, 300);

          setLoading(false);
        }, 500);
      } catch (error) {
        console.error("Export failed:", error);

        // Close current snackbar and show error
        setSnackbarOpen(false);
        setTimeout(() => {
          setSnackbarMessage("No flange data found.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }, 300);
      }
    } catch (error) {
      console.error("Export failed:", error);

      // Close current snackbar and show error
      setSnackbarOpen(false);
      setTimeout(() => {
        setSnackbarMessage("No flange data found.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }, 300);

      setLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const warningDropdowns = document.querySelectorAll(
        ".bulk-warnings-dropdown-menu.show",
      );
      warningDropdowns.forEach((menu) => {
        const toggle = menu.previousElementSibling;
        if (toggle && !toggle.contains(e.target) && !menu.contains(e.target)) {
          menu.classList.remove("show");
          toggle.setAttribute("aria-expanded", "false");
        }
      });
    };

    if (isWarningModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isWarningModalOpen]);

  const isAllSelected = selectedWarningType.length === warningTypes.length;
  const toggleSelectAll = () => {
    setSelectedWarningType(
      isAllSelected ? [] : warningTypes.map((t) => t.code),
    );
  };
  const toggleType = (code) => {
    setSelectedWarningType((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code],
    );
  };

  return (
    <div>
      {pageLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backdropFilter: "blur(6px)",
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              transform: "scale(2)",
              gap: "10px",
            }}
          >
            <Loader />
          </div>
        </div>
      )}
      <div
        className={`table-container ${
          isSidebarExpanded ? "expanded" : "collapsed"
        } all-flanges-page`}
        style={{
          padding: "unset !important",
          minHeight: "unset !important",
          borderRadius: "0px",
        }}
      >
        <div
          className="table-container-content"
          style={{ padding: "10px 20px" }}
        >
          <div className="table-header">
            <div className="table-header-content">
              <div className="table-left-side">
                <h2 className="page-title mb-0">Flanges</h2>
              </div>
              <div className="table-right-side">
                <SearchBar
                  placeholder="Search Flanges..."
                  value={searchQuery}
                  useLocalFiltering={false}
                  onResults={({ query }) => {
                    handleSearchChange(query);
                  }}
                />

                {selectedFlanges.length > 0 && (
                  <button
                    className="import-button mb-3"
                    onClick={() => handleCertificatePrint()}
                    disabled={tagPrintPreparing}
                  >
                    <MdOutlinePrint size={20} />
                    {tagPrintPreparing ? "Preparing..." : "Print"}
                  </button>
                )}

                <button
                  className="import-button mb-3"
                  onClick={handlePrintAllTags}
                  disabled={printingAllTags}
                  title="Generate a PDF of tags for all flanges matching the current filters"
                >
                  <MdLocalPrintshop size={20} />
                  {printingAllTags ? "Preparing..." : "Print All Tags"}
                </button>

                <button
                  className="import-button mb-3"
                  onClick={handleExport}
                  style={{ visibility: "visible" }} // Keep space reserved
                >
                  <PiExport />
                  Export
                </button>
                {/* <button
                className="all-flanges-new-btn mb-3"
                onClick={handleNewFlangeClick}
                type="button"
              >
                + New
              </button> */}

                <AllTags
                  activeTab={activeTab}
                  selectedProjectId={selectedProject?.id || selectedProject}
                  canImport={isAdmin}
                />
              </div>
            </div>
          </div>

          {/* {errorMessage && <p className="error-text">{errorMessage}</p>} */}

          {/* {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )} */}

          <div
            className="tab-bar d-flex justify-content-between mb-3 gap-2"
            style={{ width: "100%" }}
          >
              <div className="d-flex war-tab-bg">
                <button
                  className={`tab-btn flange-primary-tab d-flex align-items-center px-3 py-2 ${
                    activeTab === "All Flanges" ? "tab-btn-active" : ""
                  }`}
                  onClick={() => setActiveTab("All Flanges")}
                >
                  <LuLayers size={20} className="me-2" />
                  <span className="me-2 fw-semibold">All Flanges</span>
                </button>

                <button
                  className={`tab-btn flange-primary-tab d-flex align-items-center px-3 py-2 ${
                    activeTab === "All Warnings" ? "tab-btn-active" : ""
                  }`}
                  onClick={() => setActiveTab("All Warnings")}
                >
                  <IoWarningOutline size={20} className="me-2" />
                  <span className="me-2 fw-semibold">Warnings</span>
                </button>
              </div>

            {/* Filter Options */}
            <div className="d-flex gap-3 align-items-center">
              <StatusFilter
                projectId={selectedProject?.id || selectedProject} // works for object or id
                selected={selectedStatuses}
                onChange={handleStatusesChange}
                disabled={loading}
              />

              <EquipmentNameDropdown
                projectId={selectedProject?.id || selectedProject}
                selected={selectedEquipNames}
                onChange={handleEquipNamesChange}
                disabled={loading}
              />

              <EquipmentNumberDropdown
                projectId={selectedProject?.id || selectedProject}
                selected={selectedEquipNumbers}
                onChange={handleEquipNumbersChange}
                disabled={loading}
              />
            </div>

            {/* Only show the button when activeTab is "All Warnings" */}
            {activeTab === "All Warnings" && (
              <div className="war-tab-bg">
                <button
                  className="tab-btn d-flex align-items-center px-3 py-2 tab-btn-sub"
                  onClick={() => setIsWarningModalOpen(true)}
                >
                  <span className="me-2 fw-semibold">Bulk Ignore Warnings</span>
                </button>
              </div>
            )}
          </div>

          {activeTab === "All Flanges" && (
            <Box
              className="all-flanges-table-card"
              sx={{
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                className="scrollbar-arrow-mask-frame all-flanges-scrollbar-mask-frame"
                sx={{ flex: 1 }}
              >
                <Box
                  className="all-flanges-table-scroll-area all-flanges-table-scroll light-scrollbar"
                  sx={{ flex: 1 }}
                >
                  <TableContainer
                    component={Paper}
                    className="all-flanges-table all-flanges-records-table"
                  >
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            size="small"
                            checked={
                              Flanges.length > 0 &&
                              selectedFlanges.length === Flanges.length
                            }
                            onChange={(e) =>
                              setSelectedFlanges(
                                e.target.checked ? [...Flanges] : [],
                              )
                            }
                          />
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell align="center">Sr.No</TableCell>
                        <TableCell align="center">Flange Number</TableCell>
                      
                        <TableCell align="center">Equip No</TableCell>
                        <TableCell align="center">Equip Group</TableCell>
                        <TableCell align="center">Size</TableCell>
                        <TableCell align="center">Rating</TableCell>
                        <TableCell align="center">Torque</TableCell>
                        <TableCell align="center">Status</TableCell>
                        
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={12} align="center">
                            Loading...
                          </TableCell>
                        </TableRow>
                      ) : Flanges.length > 0 ? (
                        Flanges.map((flange, index) => {
                          const rowFlangeId = String(
                            flange?.flange_id ?? flange?.id ?? "",
                          );
                          const isScrollHighlight =
                            rowFlangeId && highlightedFlangeId === rowFlangeId;
                          const isScrollPulse =
                            rowFlangeId && pulsedFlangeId === rowFlangeId;

                          return (
                            <TableRow
                              key={rowFlangeId || index}
                              id={
                                rowFlangeId
                                  ? `flange-row-${rowFlangeId}`
                                  : undefined
                              }
                              data-flange-id={rowFlangeId || undefined}
                              className={`${
                                isScrollHighlight
                                  ? "flange-scroll-highlight"
                                  : ""
                              } ${isScrollPulse ? "flange-scroll-pulse" : ""}`.trim()}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  size="small"
                                  checked={selectedFlanges.some(
                                    (f) => f.flange_id === flange.flange_id,
                                  )}
                                  onChange={() => {
                                    const exists = selectedFlanges.find(
                                      (f) => f.flange_id === flange.flange_id,
                                    );
                                    setSelectedFlanges(
                                      exists
                                        ? selectedFlanges.filter(
                                            (f) =>
                                              f.flange_id !== flange.flange_id,
                                          )
                                        : [...selectedFlanges, flange],
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell
                                sx={{ minWidth: "20px", color: "primary.main" }}
                              >
                                {flange.is_new}
                              </TableCell>
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {flange.serial_number || "N/A"}
                                  {flange.is_reopen && (
                                    <Tooltip
                                      title={`Reopened ${
                                        flange.reopening_count || 0
                                      } time`}
                                    >
                                      <IconButton size="small">
                                        <RiFlag2Fill
                                          size={20}
                                          color={
                                            flange.reopening_flag_color
                                              ? flange.reopening_flag_color.toLowerCase()
                                              : "gray"
                                          }
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </div>
                              </TableCell>
                              <TableCell
                                sx={{ padding: "16px" }}
                                className="all-flanges-nowrap-cell"
                              >
                                <Box
                                  className="all-flanges-flange-cell"
                                  title={flange.flange_number || "N/A"}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  {/* Flange number as hyperlink */}
                                  <span
                                    onClick={() =>
                                      handleViewClick(flange.flange_id)
                                    }
                                    className="all-flanges-link-ellipsis all-flanges-flange-link"
                                    onMouseDown={(e) => {
                                      if (window.getSelection().toString()) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                      }
                                    }}
                                  >
                                    {flange.flange_number || "N/A"}
                                  </span>

                                  {/* History icon as separate hyperlink */}
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleHistory(flange.flange_id)
                                    }
                                    className="all-flanges-history-btn"
                                  >
                                    <History fontSize="small" />
                                  </IconButton>
                                </Box>
                              </TableCell>
                              
                              <TableCell className="all-flanges-nowrap-cell">
                                <span
                                  className="all-flanges-cell-ellipsis"
                                  title={flange.equipment_number || "N/A"}
                                >
                                  {flange.equipment_number || "N/A"}
                                </span>
                              </TableCell>
                              <TableCell>
                                {flange.equipment_name || "N/A"}
                              </TableCell>
                              <TableCell>
                                {flange.flange_size || "N/A"}
                              </TableCell>
                              <TableCell className="all-flanges-nowrap-cell">
                                <span
                                  className="all-flanges-cell-ellipsis"
                                  title={flange.rating || "N/A"}
                                >
                                  {flange.rating || "N/A"}
                                </span>
                              </TableCell>
                              <TableCell className="all-flanges-nowrap-cell">
                                <span
                                  className="all-flanges-cell-ellipsis"
                                  title={flange.required_torque || "N/A"}
                                >
                                  {flange.required_torque || "N/A"}
                                </span>
                              </TableCell>
                              <TableCell>
                                <div
                                  className={`flange-status ${getStatusClass(
                                    flange.status,
                                  )}`}
                                >
                                  {flange.process_name}
                                </div>
                              </TableCell>
                              

                              <TableCell>
                                <div className="all-flanges-action-buttons">
                                  {/* <Tooltip title="View">
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleViewClick(flange.flange_id)
                                  }
                                >
                                  <GrFormView size={20} />
                                </IconButton>
                              </Tooltip> */}
                                  {/* <Tooltip title="View">
                                <IconButton size="small">
                                  <RiFlag2Fill size={20} />
                                </IconButton>
                              </Tooltip> */}
                                  <Tooltip title={"Ticket"}>
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setSelectedFlangeId(flange.flange_id); // store id
                                        setShowTicketModal(true);
                                      }}
                                    >
                                      <LuTicketSlash size={20} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Reopen Flange">
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setReOpenTargetId(flange.flange_id);
                                        setReOpenOpen(true);
                                      }}
                                    >
                                      <GoIssueReopened size={20} />
                                    </IconButton>
                                  </Tooltip>

                                  {(() => {
                                    const isDeleted =
                                      archivedMap[flange.flange_id] ??
                                      Boolean(flange.is_deleted); // Use is_deleted from backend

                                    return isDeleted ? (
                                      <Tooltip title="Un-Archive">
                                        <IconButton
                                          size="small"
                                          style={{ color: "#23a203ff" }} // Green color for deleted/archived items
                                          onClick={() => {
                                            setAuAction("unarchive");
                                            setAuTargetId(flange.flange_id);
                                            setAuRemark("");
                                            setAuOpen(true);
                                          }}
                                        >
                                          <MdOutlineUnarchive size={20} />
                                        </IconButton>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip title="Archive">
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            setAuAction("archive");
                                            setAuTargetId(flange.flange_id);
                                            setAuRemark("");
                                            setAuOpen(true);
                                          }}
                                        >
                                          <MdOutlineArchive size={20} />
                                        </IconButton>
                                      </Tooltip>
                                    );
                                  })()}
                                  <Tooltip
                                    title={flange.qr_alert_message || "QR Code"}
                                  >
                                    <Badge
                                      badgeContent="!"
                                      color="error"
                                      invisible={!flange.qr_alert_message}
                                      sx={{
                                        "& .MuiBadge-badge": {
                                          fontSize: "11px",
                                          height: "18px",
                                          minWidth: "18px",
                                          padding: "0",
                                          fontWeight: "bold",
                                          top: "6px",
                                          right: "6px",
                                          border: "2px solid white",
                                          animation: flange.qr_alert_message
                                            ? "pulse 2s infinite"
                                            : "none",
                                        },
                                        "@keyframes pulse": {
                                          "0%": {
                                            boxShadow:
                                              "0 0 0 0 rgba(255, 0, 0, 0.7)",
                                          },
                                          "70%": {
                                            boxShadow:
                                              "0 0 0 6px rgba(255, 0, 0, 0)",
                                          },
                                          "100%": {
                                            boxShadow:
                                              "0 0 0 0 rgba(255, 0, 0, 0)",
                                          },
                                        },
                                      }}
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={() => handleViewQRCode(flange)}
                                      >
                                        <LiaQrcodeSolid size={20} />
                                      </IconButton>
                                    </Badge>
                                  </Tooltip>
                                  <Tooltip title={"Edit"}>
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleEditClick(flange.flange_id)
                                      }
                                    >
                                      <BiEditAlt size={20} />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={13} align="center">
                            {errorMessage || "No data available"}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  </TableContainer>
                </Box>
                <Box
                  aria-hidden="true"
                  className="scrollbar-arrow-mask scrollbar-arrow-mask--vertical-top"
                />
                <Box
                  aria-hidden="true"
                  className="scrollbar-arrow-mask scrollbar-arrow-mask--vertical-bottom"
                />
                <Box
                  aria-hidden="true"
                  className="scrollbar-arrow-mask scrollbar-arrow-mask--horizontal-left"
                />
                <Box
                  aria-hidden="true"
                  className="scrollbar-arrow-mask scrollbar-arrow-mask--horizontal-right"
                />
              </Box>
              <Box className="all-flanges-pagination-footer">
                <PaginationFooter
                  totalRecords={totalRecords}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
                />
              </Box>
            </Box>
          )}

          {activeTab === "All Warnings" && (
            <Box
              className="all-flanges-table-card"
              sx={{
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box className="all-flanges-table-scroll-area" sx={{ flex: 1 }}>
                <TableContainer component={Paper} className="all-flanges-table">
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            size="small"
                            checked={
                              Flanges.length > 0 &&
                              selectedFlanges.length === Flanges.length
                            }
                            onChange={(e) =>
                              setSelectedFlanges(
                                e.target.checked ? [...Flanges] : [],
                              )
                            }
                          />
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell align="center">Sr.No</TableCell>
                       
                        <TableCell align="center">Flange Number</TableCell>
                        <TableCell align="center">Equip No</TableCell>
                        <TableCell align="center">Equip Group</TableCell>
                        <TableCell align="center">Size</TableCell>
                        <TableCell align="center">Rating</TableCell>
                        <TableCell align="center">Torque</TableCell>
                        <TableCell align="center">Status</TableCell>
                       
                        <TableCell align="center" sx={{ minWidth: 200 }}>
                          Warnings
                        </TableCell>
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={12} align="center">
                            Loading...
                          </TableCell>
                        </TableRow>
                      ) : Flanges.length > 0 ? (
                        Flanges.map((flange, index) => {
                          const rowFlangeId = String(
                            flange?.flange_id ?? flange?.id ?? "",
                          );
                          const isScrollHighlight =
                            rowFlangeId && highlightedFlangeId === rowFlangeId;
                          const isScrollPulse =
                            rowFlangeId && pulsedFlangeId === rowFlangeId;

                          return (
                            <TableRow
                              key={rowFlangeId || index}
                              id={
                                rowFlangeId
                                  ? `flange-row-${rowFlangeId}`
                                  : undefined
                              }
                              data-flange-id={rowFlangeId || undefined}
                              className={`${
                                isScrollHighlight
                                  ? "flange-scroll-highlight"
                                  : ""
                              } ${isScrollPulse ? "flange-scroll-pulse" : ""}`.trim()}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  size="small" // <-- This makes the checkbox smaller
                                  checked={selectedFlanges.some(
                                    (f) => f.flange_id === flange.flange_id,
                                  )}
                                  onChange={() => {
                                    const exists = selectedFlanges.find(
                                      (f) => f.flange_id === flange.flange_id,
                                    );
                                    setSelectedFlanges(
                                      exists
                                        ? selectedFlanges.filter(
                                            (f) =>
                                              f.flange_id !== flange.flange_id,
                                          )
                                        : [...selectedFlanges, flange],
                                    );
                                  }}
                                />
                              </TableCell>

                              <TableCell
                                sx={{ minWidth: "20px", color: "primary.main" }}
                              >
                                {flange.is_new}
                              </TableCell>
                              <TableCell sx={{ minWidth: "20px" }}>
                                {flange.serial_number || "N/A"}
                              </TableCell>
                              
                              <TableCell
                                sx={{ padding: "16px" }}
                                className="all-flanges-nowrap-cell"
                              >
                                <Box
                                  className="all-flanges-flange-cell"
                                  title={flange.flange_number || "N/A"}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  {/* Flange number as hyperlink */}
                                  <span
                                    onClick={() =>
                                      handleViewClick(flange.flange_id)
                                    }
                                    className="all-flanges-link-ellipsis all-flanges-flange-link"
                                    onMouseDown={(e) => {
                                      if (window.getSelection().toString()) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                      }
                                    }}
                                  >
                                    {flange.flange_number || "N/A"}
                                  </span>

                                  {/* History icon as separate hyperlink */}
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleHistory(flange.flange_id)
                                    }
                                    className="all-flanges-history-btn"
                                  >
                                    <History fontSize="small" />
                                  </IconButton>
                                </Box>
                              </TableCell>
                              <TableCell className="all-flanges-nowrap-cell">
                                <span
                                  className="all-flanges-cell-ellipsis"
                                  title={flange.equipment_number || "N/A"}
                                >
                                  {flange.equipment_number || "N/A"}
                                </span>
                              </TableCell>
                              <TableCell>
                                {flange.equipment_name || "N/A"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  minWidth: 80,
                                  maxWidth: 100,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {flange.flange_size || "N/A"}
                              </TableCell>

                               <TableCell
                                style={{ minWidth: "20px" }}
                                className="all-flanges-nowrap-cell"
                              >
                                <span
                                  className="all-flanges-cell-ellipsis"
                                  title={flange.rating || "N/A"}
                                >
                                  {flange.rating || "N/A"}
                                </span>
                              </TableCell>
                              <TableCell
                                sx={{ minWidth: "20px" }}
                                className="all-flanges-nowrap-cell"
                              >
                                <span
                                  className="all-flanges-cell-ellipsis"
                                  title={flange.required_torque || "N/A"}
                                >
                                  {flange.required_torque || "N/A"}
                                </span>
                              </TableCell>

                              <TableCell>
                                <div
                                  className={`flange-status ${getStatusClass(
                                    flange.status,
                                    flange.process_name,
                                  )}`}
                                >
                                  {flange.process_name}
                                </div>
                              </TableCell>
                             

                              {/* <TableCell >
                          {flange.warning_codes?.length > 0 ? (
                            flange.warning_codes.map((w, i) => (
                              <div key={i} className="text-danger small">⚠️ {w.default_message}</div>
                            ))
                          ) : (
                            <span className="text-muted">No Warnings</span>
                          )}
                        </TableCell> */}

                              <TableCell align="center">
                                {flange.warning_codes?.length > 0 ? (
                                  <div
                                    className="text-danger small"
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => handleWarningClick(flange)}
                                  >
                                    {flange.warning_codes.length} ⚠️ Warning(s)
                                  </div>
                                ) : (
                                  <span className="text-muted">
                                    No Warnings
                                  </span>
                                )}
                              </TableCell>

                              <TableCell>
                                <div className="all-flanges-action-buttons">
                                  {/* {flange.is_reopen && (
                                <Tooltip title="Reopened">
                                  <IconButton size="small">
                                    <RiFlag2Fill size={20} color="red" />
                                  </IconButton>
                                </Tooltip>
                              )} */}

                                  {/* <IconButton
                                size="small"
                                onClick={() => handleViewQRCode(flange)}
                              >
                                <LiaQrcodeSolid size={20} />
                              </IconButton> */}
                                  <Tooltip title="Edit">
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleEditClick(flange.flange_id)
                                      }
                                    >
                                      <BiEditAlt size={20} />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={13} align="center">
                            No data available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box className="all-flanges-pagination-footer">
                <PaginationFooter
                  totalRecords={totalRecords}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
                />
              </Box>
            </Box>
          )}
        </div>

        {/* warning avoid modal in button */}

        {isWarningModalOpen && (
          <div
            className="bulk-warnings-modal-overlay"
            onClick={(e) => {
              if (e.target.className === "bulk-warnings-modal-overlay") {
                handleCloseWarningModal();
              }
            }}
          >
            <div
              className="bulk-warnings-modal-container"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="bulk-warnings-modal-header">
                <IoWarningOutline className="bulk-warnings-icon" />
                <h4 className="bulk-warnings-modal-title">
                  Bulk Ignore Warnings
                </h4>
              </div>

              {/* Body - Scrollable */}
              <div className="bulk-warnings-modal-body">
                {/* Warning Type Multi-Select */}
                <div className="bulk-warnings-form-group">
                  <label className="bulk-warnings-form-label">
                    Warning Types
                  </label>

                  <div className="bulk-warnings-types-dropdown">
                    <button
                      type="button"
                      className="bulk-warnings-dropdown-toggle"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsTypesOpen((v) => !v);
                      }}
                      aria-expanded={isTypesOpen}
                    >
                      {selectedWarningType.length ? (
                        `${selectedWarningType.length} warning type(s) selected`
                      ) : (
                        <span className="bulk-warnings-dropdown-placeholder">
                          Select warning types...
                        </span>
                      )}
                    </button>

                    <div
                      className={`bulk-warnings-dropdown-menu ${
                        isTypesOpen ? "show" : ""
                      }`}
                    >
                      {/* SELECT ALL (sticky top) */}
                      <div
                        className="bulk-warnings-dropdown-item bulk-warnings-select-all"
                        role="button"
                        tabIndex={0}
                        onClick={toggleSelectAll}
                        onKeyDown={(e) =>
                          (e.key === "Enter" || e.key === " ") &&
                          toggleSelectAll()
                        }
                      >
                        <div className="bulk-warnings-checkbox-wrapper">
                          <input
                            className="bulk-warnings-checkbox"
                            type="checkbox"
                            id="bulk-warning-select-all"
                            checked={isAllSelected}
                            onChange={toggleSelectAll}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <label
                            className="bulk-warnings-checkbox-label"
                            htmlFor="bulk-warning-select-all"
                          >
                            Select all
                          </label>
                        </div>
                      </div>

                      {/* INDIVIDUAL TYPES */}
                      {warningTypes.map((type) => {
                        const checked = selectedWarningType.includes(type.code);
                        return (
                          <div
                            key={type.code}
                            className={`bulk-warnings-dropdown-item ${
                              checked ? "is-selected" : ""
                            }`}
                            role="button"
                            tabIndex={0}
                            onClick={() => toggleType(type.code)}
                            onKeyDown={(e) =>
                              (e.key === "Enter" || e.key === " ") &&
                              toggleType(type.code)
                            }
                          >
                            <div className="bulk-warnings-checkbox-wrapper">
                              <input
                                className="bulk-warnings-checkbox"
                                type="checkbox"
                                id={`bulk-warning-${type.code}`}
                                checked={checked}
                                onChange={() => toggleType(type.code)}
                                onClick={(e) => e.stopPropagation()} // keep row click working
                              />
                              <label
                                className="bulk-warnings-checkbox-label"
                                htmlFor={`bulk-warning-${type.code}`}
                              >
                                {type.label}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* Scope Radio */}
                <div className="bulk-warnings-form-group">
                  <label className="bulk-warnings-form-label">
                    Ignore Scope
                  </label>
                  <div className="bulk-warnings-radio-group">
                    <div className="bulk-warnings-radio-wrapper">
                      <input
                        type="radio"
                        className="bulk-warnings-radio"
                        id="bulk-scope-equipment-name"
                        value="equipment_name"
                        checked={ignoreScope === "equipment_name"}
                        onChange={() => setIgnoreScope("equipment_name")}
                      />
                      <label
                        className="bulk-warnings-radio-label"
                        htmlFor="bulk-scope-equipment-name"
                      >
                        Equipment Name
                      </label>
                    </div>
                    <div className="bulk-warnings-radio-wrapper">
                      <input
                        type="radio"
                        className="bulk-warnings-radio"
                        id="bulk-scope-equipment-number"
                        value="equipment_number"
                        checked={ignoreScope === "equipment_number"}
                        onChange={() => setIgnoreScope("equipment_number")}
                      />
                      <label
                        className="bulk-warnings-radio-label"
                        htmlFor="bulk-scope-equipment-number"
                      >
                        Equipment Number
                      </label>
                    </div>
                    <div className="bulk-warnings-radio-wrapper">
                      <input
                        type="radio"
                        className="bulk-warnings-radio"
                        id="bulk-scope-project"
                        value="project"
                        checked={ignoreScope === "project"}
                        onChange={() => setIgnoreScope("project")}
                      />
                      <label
                        className="bulk-warnings-radio-label"
                        htmlFor="bulk-scope-project"
                      >
                        Project Level
                      </label>
                    </div>
                  </div>
                </div>

                <div className="">
                  {/* Equipment Multi-Select - Using your existing component */}
                  {ignoreScope === "equipment_name" && (
                    <div
                      className="bulk-warnings-form-group"
                      style={{ marginBottom: "12px" }}
                    >
                      <EquipmentMultiSelectDropdown
                        ignoreScope={ignoreScope}
                        uniqueEquipmentWar={uniqueEquipmentWar}
                        selectedEquipment={selectedEquipment}
                        setSelectedEquipment={setSelectedEquipment}
                        selectedProject={selectedProject}
                        setSelectedGroup={setSelectedEquipmentName}
                        selectedGroup={selectedEquipmentName}
                        closeDropdown={() => {
                          setGroupDropdownOpen(false);
                          setDropdownOpen(false);
                        }}
                      />
                    </div>
                  )}

                  {ignoreScope === "equipment_number" && (
                    <div
                      className="bulk-warnings-form-group"
                      style={{ marginBottom: "12px" }}
                    >
                      <EquipmentMultiSelectDropdown
                        ignoreScope={ignoreScope}
                        uniqueEquipmentWar={uniqueEquipmentWar}
                        selectedEquipment={selectedEquipmentNumbers}
                        setSelectedEquipment={setSelectedEquipmentNumbers}
                        selectedProject={selectedProject}
                        setSelectedGroup={() => {}}
                        selectedGroup={""}
                        closeDropdown={() => {
                          setGroupDropdownOpen(false);
                          setDropdownOpen(false);
                        }}
                      />
                    </div>
                  )}
                </div>

                {/* Reason Textarea */}
                <div className="bulk-warnings-form-group mt-5">
                  <label className="bulk-warnings-form-label">
                    Reason for Ignoring Warning
                  </label>
                  <textarea
                    className="bulk-warnings-textarea"
                    rows="3"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Enter reason for ignoring these warnings..."
                  />
                </div>

                {/* Summary */}
                <div className="bulk-warnings-summary">
                  <div className="bulk-warnings-summary-title">Summary:</div>

                  {selectedWarningType.length > 0 && (
                    <div className="bulk-warnings-summary-section">
                      <div className="bulk-warnings-summary-label">
                        Warning Types:
                      </div>
                      <ul className="bulk-warnings-summary-list">
                        {selectedWarningType.map((code) => {
                          const warning = warningTypes.find(
                            (w) => w.code === code,
                          );
                          return <li key={code}>{warning?.label || code}</li>;
                        })}
                      </ul>
                    </div>
                  )}

                  {ignoreScope === "equipment_name" &&
                    selectedEquipmentName.length > 0 && (
                      <div className="bulk-warnings-summary-section">
                        <p className="bulk-warnings-summary-text">
                          <strong>Selected Equipment Name:</strong>{" "}
                          {Array.isArray(selectedEquipmentName)
                            ? selectedEquipmentName.join(", ")
                            : selectedEquipmentName}
                        </p>
                      </div>
                    )}

                  {ignoreScope === "equipment_number" &&
                    selectedEquipmentNumbers.length > 0 && (
                      <div className="bulk-warnings-summary-section">
                        <p className="bulk-warnings-summary-text">
                          <strong>Selected Equipment Numbers:</strong>{" "}
                          {selectedEquipmentNumbers.length}
                        </p>
                      </div>
                    )}

                  {ignoreScope === "project" && (
                    <div className="bulk-warnings-summary-section">
                      <p className="bulk-warnings-summary-text">
                        <strong>Project Level:</strong> All equipment will be
                        ignored for these warnings
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="bulk-warnings-modal-footer">
                <button
                  className="bulk-warnings-btn bulk-warnings-btn-cancel"
                  onClick={handleCloseWarningModal}
                >
                  Cancel
                </button>
                <button
                  className="bulk-warnings-btn bulk-warnings-btn-submit"
                  onClick={handleIgnoreWarning}
                  disabled={
                    selectedWarningType.length === 0 ||
                    (ignoreScope === "equipment_name" &&
                      (Array.isArray(selectedEquipmentName)
                        ? selectedEquipmentName.length === 0
                        : !selectedEquipmentName)) ||
                    (ignoreScope === "equipment_number" &&
                      selectedEquipmentNumbers.length === 0)
                  }
                >
                  Ignore Warning for Flange(s)
                </button>
              </div>
            </div>
          </div>
        )}

        {/* warning avoid in table   */}

        {showWarningModal && selectedFlange && (
          <Modal open={true} onClose={() => setShowWarningModal(false)}>
            <Box
              sx={{
                width: 420,
                bgcolor: "background.paper",
                p: 3,
                borderRadius: 2,
                boxShadow: 24,
                mx: "auto",
                mt: "10%",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Warnings for {selectedFlange.equipment_number}
              </Typography>

              <Box sx={{ maxHeight: 300, overflowY: "auto", mb: 2 }}>
                {selectedFlange.warning_codes?.map((w, idx) => {
                  const code = w?.code;

                  if (!code || typeof code !== "string") return null;

                  return (
                    <FormControlLabel
                      key={code}
                      control={
                        <Checkbox
                          checked={selectedWarnings.includes(code)}
                          onChange={() => toggleWarningSelection(code)}
                        />
                      }
                      label={`[${code}] ${
                        w?.default_message ?? "⚠️ No description found"
                      }`}
                    />
                  );
                })}
              </Box>

              <textarea
                className="form-control mb-3"
                rows="3"
                placeholder="Reason for avoiding warning(s)..."
                value={avoidReason}
                onChange={(e) => setAvoidReason(e.target.value)}
              />

              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  onClick={() => setShowWarningModal(false)}
                >
                  Cancel
                </button>

                {/* <Button
         className="btn btn-outline-secondary"
          variant="outlined"
          color="secondary"
          onClick={() => setShowWarningModal(false)}
        >
          Cancel
        </Button> */}

                <Button
                  variant="contained"
                  color="primary"
                  disabled={selectedWarnings.length === 0}
                  onClick={handleAvoidWarnings}
                >
                  Avoid Selected
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}

        {showQRModal && (
          <div className="modal-overlay">
            <div className="shared-qr-modal-content">
              <div className="shared-qr-modal-header">
                <h4 className="shared-qr-modal-title">Flange Tag Preview</h4>
              </div>

              {tagPreviewLoading || !selectedFlange ? (
                <div className="shared-qr-code-empty">Loading tag preview...</div>
              ) : (
                <div className="flange-tag-preview-modal">
                  <div className="flange-tag-preview-body">
                    <div className="flange-tag-preview-stage">
                      <FlangeTagContent flange={selectedFlange} />
                    </div>
                  </div>
                </div>
              )}

              <div className="shared-qr-modal-footer">
                <button
                  className="flange-tag-action-btn flange-tag-action-btn--primary"
                  onClick={handlePrintSelectedTag}
                  disabled={tagPrintPreparing || tagPreviewLoading || !selectedFlange}
                >
                  {tagPrintPreparing ? "Preparing..." : "Print Tag"}
                </button>

                <button
                  className="flange-tag-action-btn flange-tag-action-btn--secondary"
                  onClick={() => setShowQRModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              width: { xs: "calc(100vw - 16px)", sm: "92vw", md: "80vw" },
              maxWidth: { xs: "calc(100vw - 16px)", sm: "900px", md: "1120px" },
              height: { xs: "calc(100vh - 16px)", sm: "90vh" },
              maxHeight: { xs: "calc(100vh - 16px)", sm: "90vh" },
              m: { xs: "8px", sm: 2 },
              borderRadius: { xs: "10px", sm: "12px" },
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle>
            {/* <img src="/jecon.png" alt="Logo" className="view-logo" /> */}
            {/* Flange Details */}
          </DialogTitle>
          <DialogContent sx={{ p: { xs: 1, sm: 2 } }}>
            <div className="qr-view">
              <FlangeDetails
                flangeId={selectedFlangeId}
                onClose={handleCloseDialog}
              />
            </div>
          </DialogContent>
        </Dialog>

        {/* Render the certificate modal if a certificate is selected */}
        {/* {selectedCertificateId && (
        <Certificate
          flange_id={selectedCertificateId}
          onClose={() => setSelectedCertificateId(null)}
        />
      )} */}

        <ToastContainer
          containerId="main"
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false} // prevent click-bubble close race
          pauseOnFocusLoss={false} // avoid focus loss during download
          draggable
          pauseOnHover
          theme="light"
        />

        {/* ---------- Ticket Modal --------- */}
        {showTicketModal && (
          <Dialog
            open={showTicketModal}
            onClose={handleCloseTicketModal}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              className: "ticket-modal-paper",
              sx: {
                borderRadius: 3,
                boxShadow: "0 24px 60px rgba(15, 23, 42, 0.18)",
                overflow: "hidden",
              },
            }}
          >
            <DialogTitle
              sx={{
                pb: 1.75,
                pt: 2.25,
                px: 3,
                borderBottom: "1px solid #edf0f5",
                background:
                  "linear-gradient(180deg, #ffffff 0%, #fbfcff 100%)",
                position: "relative",
              }}
            >
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#111827",
                    fontWeight: 700,
                    fontSize: "1.08rem",
                    lineHeight: 1.3,
                  }}
                >
                  Create Ticket
                </Typography>
              </Box>
              <IconButton
                onClick={handleCloseTicketModal}
                aria-label="Close ticket modal"
                sx={{
                  position: "absolute",
                  right: 16,
                  top: 14,
                  color: "#64748b",
                  border: "1px solid #e5e7eb",
                  width: 34,
                  height: 34,
                  "&:hover": {
                    color: "#111827",
                    bgcolor: "#f8fafc",
                    borderColor: "#cbd5e1",
                  },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>

            <DialogContent sx={{ px: 3, py: 2.5, bgcolor: "#fbfcff" }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.25 }}>
                <TicketModalTextFields
                  titleRef={ticketTitleRef}
                  descriptionRef={ticketDescriptionRef}
                  onTitlePresenceChange={setHasTicketTitle}
                />

                {/* Ticket Type */}
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 500, fontSize: "0.85rem" }}
                  >
                    Ticket Type <span style={{ color: "#d32f2f" }}>*</span>
                  </Typography>
                  <MUISelect
                    value={ticketType || ""}
                    onChange={(e) => setTicketType(e.target.value)}
                    displayEmpty
                    fullWidth
                    size="small"
                    renderValue={(selected) =>
                      selected ? (
                        selected
                      ) : (
                        <span style={{ color: "#999" }}>Select type</span>
                      )
                    }
                    sx={{
                      fontSize: "0.875rem",
                      "& .MuiSelect-select": { py: 1.25 },
                    }}
                  >
                    <MenuItem value="" disabled>
                      <em>Select type</em>
                    </MenuItem>
                    <MenuItem value="Alert">Alert</MenuItem>
                    <MenuItem value="Missing Information">
                      Missing Information
                    </MenuItem>
                  </MUISelect>
                </Box>

                {/* Priority */}
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 500, fontSize: "0.85rem" }}
                  >
                    Priority <span style={{ color: "#d32f2f" }}>*</span>
                  </Typography>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "repeat(2, minmax(0, 1fr))",
                        sm: "repeat(4, minmax(0, 1fr))",
                      },
                      gap: 1,
                    }}
                  >
                    {TICKET_PRIORITY_OPTIONS.map((option) => {
                      const selected = ticketPriority === option.value;
                      return (
                        <Box
                          key={option.value}
                          onClick={() => setTicketPriority(option.value)}
                          sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 0.75,
                            py: 1.15,
                            border: "1px solid",
                            borderColor: selected ? option.color : "divider",
                            borderRadius: 2,
                            cursor: "pointer",
                            bgcolor: selected
                              ? `${option.color}14`
                              : "#ffffff",
                            transition: "all 0.15s ease",
                            boxShadow: selected
                              ? `0 8px 18px ${option.color}1f`
                              : "0 1px 2px rgba(15, 23, 42, 0.04)",
                            "&:hover": {
                              borderColor: option.color,
                              transform: "translateY(-1px)",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              bgcolor: option.color,
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "0.85rem",
                              fontWeight: selected ? 600 : 500,
                            }}
                          >
                            {option.value}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>

                {/* Assignment */}
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      letterSpacing: "0.06em",
                      color: "text.secondary",
                      fontSize: "0.7rem",
                    }}
                  >
                    ASSIGNMENT
                  </Typography>
                  <Box
                    sx={{
                      borderBottom: "1px solid",
                      borderColor: "#e7ebf3",
                      mt: 0.75,
                      mb: 1.5,
                    }}
                  />

                  <Box sx={{ mb: 1.5 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.75, fontWeight: 500, fontSize: "0.85rem" }}
                    >
                      Assign to people
                    </Typography>
                    <Autocomplete
                      multiple
                      size="small"
                      disablePortal
                      slotProps={TICKET_AUTOCOMPLETE_SLOT_PROPS}
                      options={assignableUsers}
                      value={ticketAssigneeUsers}
                      onChange={(e, value) => setTicketAssigneeUsers(value)}
                      filterOptions={filterTicketAssigneeUsers}
                      getOptionLabel={(option) =>
                        option?.name
                          ? `${option.name} ${getTicketUserDepartmentLabel(option)}`
                          : ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      disableCloseOnSelect
                      loading={assignablesLoading}
                      noOptionsText="No project members found"
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        const departments = getTicketUserDepartments(option);
                        return (
                          <li key={key || option.id} {...optionProps}>
                            <Checkbox
                              icon={
                                <CheckBoxOutlineBlankIcon fontSize="small" />
                              }
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              checked={selected}
                              size="small"
                              sx={{
                                mr: 1,
                                color: "#64748b",
                                "&.Mui-checked": { color: "#991b1b" },
                              }}
                            />
                            <Box sx={{ minWidth: 0 }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#111827",
                                  fontSize: "0.86rem",
                                  fontWeight: 600,
                                  lineHeight: 1.25,
                                }}
                              >
                                {option.name}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "#64748b",
                                  display: "block",
                                  fontSize: "0.72rem",
                                  lineHeight: 1.25,
                                  mt: 0.25,
                                }}
                              >
                                {departments.length
                                  ? getTicketUserDepartmentText(option)
                                  : "No department"}
                              </Typography>
                            </Box>
                          </li>
                        );
                      }}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            {...getTagProps({ index })}
                            key={option.id}
                            label={getTicketUserChipLabel(option)}
                            size="small"
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search team members..."
                        />
                      )}
                    />
                  </Box>

                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.75, fontWeight: 500, fontSize: "0.85rem" }}
                    >
                      Assign to departments
                    </Typography>
                    <Autocomplete
                      multiple
                      size="small"
                      disablePortal
                      slotProps={TICKET_AUTOCOMPLETE_SLOT_PROPS}
                      options={assignableDepartments}
                      value={ticketAssigneeDepartments}
                      onChange={(e, value) =>
                        setTicketAssigneeDepartments(
                          withMandatoryDepartments(value, assignableDepartments),
                        )
                      }
                      filterOptions={filterTicketDepartments}
                      getOptionLabel={(option) => option?.name || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      getOptionDisabled={(option) => Boolean(option.mandatory)}
                      disableCloseOnSelect
                      loading={assignablesLoading}
                      noOptionsText="No departments found"
                      renderOption={(props, option, { selected }) => (
                        <li {...props} key={option.id}>
                          <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            checked={selected}
                            size="small"
                            sx={{
                              mr: 1,
                              color: "#64748b",
                              "&.Mui-checked": { color: "#991b1b" },
                            }}
                          />
                          {option.name}
                          {option.mandatory && (
                            <Typography
                              component="span"
                              sx={{
                                ml: "auto",
                                fontSize: "0.7rem",
                                color: "#991b1b",
                              }}
                            >
                              Always assigned
                            </Typography>
                          )}
                        </li>
                      )}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => {
                          const tagProps = getTagProps({ index });
                          if (option.mandatory) {
                            // Locked chip: onDelete overridden to undefined so
                            // there's no remove button — the planning team can't
                            // be removed (backend enforces this too).
                            return (
                              <Chip
                                {...tagProps}
                                onDelete={undefined}
                                key={option.id}
                                label={option.name}
                                size="small"
                                icon={<LockIcon sx={{ fontSize: "0.8rem" }} />}
                                title="Planning is always assigned and can't be removed"
                                sx={{ "& .MuiChip-icon": { color: "#991b1b" } }}
                              />
                            );
                          }
                          return (
                            <Chip
                              {...tagProps}
                              key={option.id}
                              label={option.name}
                              size="small"
                            />
                          );
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search departments..."
                        />
                      )}
                    />
                  </Box>
                </Box>

                {/* Attachments */}
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      letterSpacing: "0.06em",
                      color: "text.secondary",
                      fontSize: "0.7rem",
                    }}
                  >
                    ATTACHMENTS
                  </Typography>
                  <Box
                    sx={{
                      borderBottom: "1px solid",
                      borderColor: "#e7ebf3",
                      mt: 0.75,
                      mb: 1.5,
                    }}
                  />

                  <Box
                    component="label"
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    sx={{
                      display: "block",
                      width: "100%",
                      p: 2,
                      border: "2px dashed",
                      borderColor: isDragging ? "#7c2d12" : "#d6dbe6",
                      borderRadius: 2.5,
                      textAlign: "center",
                      cursor: "pointer",
                      bgcolor: isDragging ? "#fff7ed" : "#ffffff",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        borderColor: "#991b1b",
                        bgcolor: "#fffafa",
                      },
                    }}
                  >
                    <CloudUploadIcon
                      sx={{
                        fontSize: 32,
                        color: "#991b1b",
                        mb: 0.5,
                        transform: isDragging ? "scale(1.1)" : "scale(1)",
                        transition: "transform 0.2s ease",
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "0.8rem",
                        mb: 0.25,
                        fontWeight: isDragging ? 600 : 400,
                      }}
                    >
                      {isDragging ? (
                        "Drop files here"
                      ) : (
                        <>
                          Drag &amp; drop files here or{" "}
                          <span
                            style={{ color: "#991b1b", fontWeight: 700 }}
                          >
                            browse
                          </span>
                        </>
                      )}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ fontSize: "0.7rem", color: "text.secondary" }}
                    >
                      images &amp; video up to 5 MB
                    </Typography>
                    <input
                      type="file"
                      multiple
                      accept="image/jpeg,image/png,image/jpg,video/mp4,video/quicktime"
                      onChange={(e) => {
                        const files = e.target.files;
                        if (files && files.length > 0) {
                          setTicketAttachments((prev) => [
                            ...prev,
                            ...Array.from(files),
                          ]);
                        }
                        e.target.value = "";
                      }}
                      hidden
                    />
                  </Box>

                  {ticketAttachments.length > 0 && (
                    <Box
                      sx={{
                        mt: 1.5,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      {ticketAttachments.map((file, index) => (
                        <Box
                          key={`${file.name}-${index}`}
                          sx={{
                            width: "100%",
                            p: 1.25,
                            border: "1px solid",
                            borderColor: "success.main",
                            borderRadius: 1,
                            bgcolor: "#f1f8f4",
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                          }}
                        >
                          <Box
                            sx={{
                              width: 32,
                              height: 32,
                              borderRadius: 1,
                              bgcolor: "success.main",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            {file.type.startsWith("image/") ? (
                              <ImageIcon sx={{ color: "white", fontSize: 18 }} />
                            ) : (
                              <InsertDriveFileIcon
                                sx={{ color: "white", fontSize: 18 }}
                              />
                            )}
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 500, fontSize: "0.8rem" }}
                              noWrap
                            >
                              {file.name}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ fontSize: "0.7rem", color: "text.secondary" }}
                            >
                              {(file.size / 1024 / 1024).toFixed(2)} MB
                            </Typography>
                          </Box>
                          <IconButton
                            size="small"
                            onClick={() =>
                              setTicketAttachments((prev) =>
                                prev.filter((_, i) => i !== index),
                              )
                            }
                            sx={{
                              color: "text.secondary",
                              "&:hover": {
                                color: "error.main",
                                bgcolor: "rgba(211, 47, 47, 0.08)",
                              },
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              </Box>
            </DialogContent>

            <DialogActions
              sx={{
                px: 3,
                py: 1.75,
                borderTop: "1px solid #edf0f5",
                bgcolor: "#ffffff",
                gap: 1.25,
              }}
            >
              <Button
                onClick={handleCloseTicketModal}
                variant="outlined"
                disabled={loading}
                size="small"
                sx={{
                  minWidth: 90,
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.875rem",
                  borderRadius: 2,
                  borderColor: "#cbd5e1",
                  color: "#334155",
                  px: 3,
                  py: 1,
                  "&:hover": {
                    borderColor: "#94a3b8",
                    bgcolor: "#f8fafc",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmitTicket}
                variant="contained"
                disabled={
                  loading ||
                  !hasTicketTitle ||
                  !ticketType ||
                  !ticketPriority
                }
                size="small"
                sx={{
                  minWidth: 150,
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.875rem",
                  borderRadius: 2,
                  py: 1,
                  bgcolor: "#991b1b",
                  boxShadow: "0 10px 22px rgba(153, 27, 27, 0.22)",
                  "&:hover": {
                    bgcolor: "#7f1d1d",
                    boxShadow: "0 12px 26px rgba(153, 27, 27, 0.26)",
                  },
                }}
              >
                {loading ? "Submitting..." : "Create Ticket"}
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* ---------- Flange Reopened Modal --------- */}
        {reOpenOpen && (
          <ReopenFlangeDialog
            open={reOpenOpen}
            loading={reOpenSubmitting}
            onClose={() => setReOpenOpen(false)}
            onSubmit={submitReOpen}
          />
        )}

        {/* Bootstrap 5 Archive / Un-Archive Modal */}
        {auOpen && (
          <Dialog
            open={auOpen}
            onClose={() => !auSubmitting && setAuOpen(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              className: "jecon-dialog archive-flange-dialog",
              sx: {
                borderRadius: "8px",
                boxShadow: "0 18px 48px rgba(17, 24, 39, 0.22)",
              },
            }}
          >
            <DialogTitle
              sx={{
                pb: 1.5,
                pt: 2,
                px: 2.5,
                mb: 1,
                borderBottom: "1px solid",
                borderColor: "divider",
                position: "relative",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, fontSize: "1.1rem" }}
              >
                {auAction === "archive"
                  ? "Archive Flange"
                  : "Un-Archive Flange"}
              </Typography>
              <IconButton
                onClick={() => !auSubmitting && setAuOpen(false)}
                disabled={auSubmitting}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "text.secondary",
                  "&:hover": { bgcolor: "#fff1f0", color: "#b42318" },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>

            <DialogContent sx={{ px: 2.5, py: 2 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {/* Warning Alert for Archive */}
                {auAction === "archive" && (
                  <Box
                    sx={{
                      p: 1.5,
                      borderRadius: 1,
                      bgcolor: "#fff3e0",
                      border: "1px solid #ffb74d",
                      display: "flex",
                      alignItems: "start",
                      gap: 1,
                    }}
                  >
                    <Typography sx={{ fontSize: "1.1rem" }}>⚠️</Typography>
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.85rem", color: "text.primary" }}
                      >
                        <strong>Are you sure?</strong> <br /> This flange will
                        be
                        <span style={{ fontWeight: 600 }}>
                          {" "}
                          deleted from scope
                        </span>
                        . You can un-archive later if needed.
                      </Typography>
                    </Box>
                  </Box>
                )}

                {/* Remark - Native HTML Textarea */}
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 500, fontSize: "0.85rem" }}
                  >
                    Remark <span style={{ color: "#d32f2f" }}>*</span>
                  </Typography>
                  <textarea
                    className="remark-input"
                    placeholder="Type your remark..."
                    rows={3}
                    value={auRemark}
                    onChange={(e) => setAuRemark(e.target.value)}
                    disabled={auSubmitting}
                  />
                </Box>
              </Box>
            </DialogContent>

            <DialogActions
              sx={{
                px: 2.5,
                py: 1.5,
                borderTop: "1px solid",
                borderColor: "divider",
                gap: 1,
              }}
            >
              <Button
                onClick={() => setAuOpen(false)}
                variant="outlined"
                disabled={auSubmitting}
                size="small"
                sx={{
                  minWidth: 90,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  borderColor: "#d5dade",
                  color: "#4b565d",
                  backgroundColor: "#fff",
                  "&:hover": {
                    borderColor: "#c91f17",
                    color: "#b42318",
                    backgroundColor: "#fff6f5",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={submitArchiveUnarchive}
                variant="contained"
                disabled={auSubmitting}
                size="small"
                sx={{
                  minWidth: 110,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  backgroundColor: "#e1261c",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#c91f17",
                    boxShadow: "none",
                  },
                }}
              >
                {auSubmitting
                  ? "Submitting..."
                  : auAction === "archive"
                    ? "Archive"
                    : "Un-Archive"}
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Snackbar must be rendered */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={
            snackbarSeverity === "info" && loading ? null : 6000
          }
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          style={{ transform: "translateY(40px)", marginLeft: "15px" }}
        >
          <MuiAlert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </div>
    </div>
  );
}

export default AllFlanges;
